import { HTMLElement, createEvent, h, getAssetPath, proxyCustomElement } from '@stencil/core/internal/client';
export { setAssetPath, setPlatformOptions } from '@stencil/core/internal/client';
import { addKeys, instantTranslate, getCurrentLanguage, changeLanguage, onLanguageChange } from '@onviobr/services/i18n';
import { deferred } from '@onviobr/services/utils';
import WebViewer from '@pdftron/webviewer';
import { format } from 'date-fns';
import printJS from 'print-js';

var WebViewerElement;
(function (WebViewerElement) {
  WebViewerElement["header"] = "header";
  WebViewerElement["leftPanelButton"] = "leftPanelButton";
  WebViewerElement["viewControlsButton"] = "viewControlsButton";
  WebViewerElement["panToolButton"] = "panToolButton";
  WebViewerElement["selectToolButton"] = "selectToolButton";
  WebViewerElement["textSelectButton"] = "textSelectButton";
  WebViewerElement["fitButton"] = "fitButton";
  WebViewerElement["zoomOutButton"] = "zoomOutButton";
  WebViewerElement["zoomInButton"] = "zoomInButton";
  WebViewerElement["zoomOverlayButton"] = "zoomOverlayButton";
  WebViewerElement["freeHandToolGroupButton"] = "freeHandToolGroupButton";
  WebViewerElement["freeHandHighlightToolGroupButton"] = "freeHandHighlightToolGroupButton";
  WebViewerElement["freeHandHighlightToolButton"] = "freeHandHighlightToolButton";
  WebViewerElement["freeHandHighlightToolButton2"] = "freeHandHighlightToolButton2";
  WebViewerElement["freeHandHighlightToolButton3"] = "freeHandHighlightToolButton3";
  WebViewerElement["freeHandHighlightToolButton4"] = "freeHandHighlightToolButton4";
  WebViewerElement["highlightToolGroupButton"] = "highlightToolGroupButton";
  WebViewerElement["freeHandToolButton"] = "freeHandToolButton";
  WebViewerElement["freeHandToolButton2"] = "freeHandToolButton2";
  WebViewerElement["freeHandToolButton3"] = "freeHandToolButton3";
  WebViewerElement["freeHandToolButton4"] = "freeHandToolButton4";
  WebViewerElement["textToolGroupButton"] = "textToolGroupButton";
  WebViewerElement["freeTextToolGroupButton"] = "freeTextToolGroupButton";
  WebViewerElement["freeTextToolButton"] = "freeTextToolButton";
  WebViewerElement["freeTextToolButton2"] = "freeTextToolButton2";
  WebViewerElement["freeTextToolButton3"] = "freeTextToolButton3";
  WebViewerElement["freeTextToolButton4"] = "freeTextToolButton4";
  WebViewerElement["stickyToolGroupButton"] = "stickyToolGroupButton";
  WebViewerElement["highlightToolButton"] = "highlightToolButton";
  WebViewerElement["highlightToolButton2"] = "highlightToolButton2";
  WebViewerElement["highlightToolButton3"] = "highlightToolButton3";
  WebViewerElement["highlightToolButton4"] = "highlightToolButton4";
  WebViewerElement["underlineToolGroupButton"] = "underlineToolGroupButton";
  WebViewerElement["strikeoutToolGroupButton"] = "strikeoutToolGroupButton";
  WebViewerElement["underlineToolButton"] = "underlineToolButton";
  WebViewerElement["underlineToolButton2"] = "underlineToolButton2";
  WebViewerElement["underlineToolButton3"] = "underlineToolButton3";
  WebViewerElement["underlineToolButton4"] = "underlineToolButton4";
  WebViewerElement["squigglyToolButton"] = "squigglyToolButton";
  WebViewerElement["squigglyToolButton2"] = "squigglyToolButton2";
  WebViewerElement["squigglyToolButton3"] = "squigglyToolButton3";
  WebViewerElement["squigglyToolButton4"] = "squigglyToolButton4";
  WebViewerElement["strikeoutToolButton"] = "strikeoutToolButton";
  WebViewerElement["strikeoutToolButton2"] = "strikeoutToolButton2";
  WebViewerElement["strikeoutToolButton3"] = "strikeoutToolButton3";
  WebViewerElement["strikeoutToolButton4"] = "strikeoutToolButton4";
  WebViewerElement["shapeToolGroupButton"] = "shapeToolGroupButton";
  WebViewerElement["rectangleToolButton"] = "rectangleToolButton";
  WebViewerElement["ellipseToolButton"] = "ellipseToolButton";
  WebViewerElement["lineToolButton"] = "lineToolButton";
  WebViewerElement["arrowToolButton"] = "arrowToolButton";
  WebViewerElement["polylineToolButton"] = "polylineToolButton";
  WebViewerElement["polygonToolButton"] = "polygonToolButton";
  WebViewerElement["cloudToolButton"] = "cloudToolButton";
  WebViewerElement["eraserToolButton"] = "eraserToolButton";
  WebViewerElement["signatureToolButton"] = "signatureToolButton";
  WebViewerElement["stickyToolButton"] = "stickyToolButton";
  WebViewerElement["miscToolGroupButton"] = "miscToolGroupButton";
  WebViewerElement["calloutToolButton"] = "calloutToolButton";
  WebViewerElement["stampToolButton"] = "stampToolButton";
  WebViewerElement["rubberStampToolButton"] = "rubberStampToolButton";
  WebViewerElement["fileAttachmentToolButton"] = "fileAttachmentToolButton";
  WebViewerElement["cropToolButton"] = "cropToolButton";
  WebViewerElement["toolsButton"] = "toolsButton";
  WebViewerElement["toolsHeader"] = "toolsHeader";
  WebViewerElement["undoButton"] = "undoButton";
  WebViewerElement["redoButton"] = "redoButton";
  WebViewerElement["searchButton"] = "searchButton";
  WebViewerElement["menuButton"] = "menuButton";
  WebViewerElement["leftPanel"] = "leftPanel";
  WebViewerElement["noteState"] = "noteState";
  WebViewerElement["notesPanelButton"] = "notesPanelButton";
  WebViewerElement["notesPanel"] = "notesPanel";
  WebViewerElement["toggleNotesButton"] = "toggleNotesButton";
  WebViewerElement["thumbnailsPanelButton"] = "thumbnailsPanelButton";
  WebViewerElement["thumbnailsPanel"] = "thumbnailsPanel";
  WebViewerElement["thumbnailControl"] = "thumbnailControl";
  WebViewerElement["documentControl"] = "documentControl";
  WebViewerElement["outlinesPanelButton"] = "outlinesPanelButton";
  WebViewerElement["outlinesPanel"] = "outlinesPanel";
  WebViewerElement["layersPanelButton"] = "layersPanelButton";
  WebViewerElement["layersPanel"] = "layersPanel";
  WebViewerElement["bookmarksPanelButton"] = "bookmarksPanelButton";
  WebViewerElement["bookmarksPanel"] = "bookmarksPanel";
  WebViewerElement["searchPanel"] = "searchPanel";
  WebViewerElement["viewControlsOverlay"] = "viewControlsOverlay";
  WebViewerElement["defaultPageTransitionButton"] = "defaultPageTransitionButton";
  WebViewerElement["continuousPageTransitionButton"] = "continuousPageTransitionButton";
  WebViewerElement["singleLayoutButton"] = "singleLayoutButton";
  WebViewerElement["doubleLayoutButton"] = "doubleLayoutButton";
  WebViewerElement["coverLayoutButton"] = "coverLayoutButton";
  WebViewerElement["rotateCounterClockwiseButton"] = "rotateCounterClockwiseButton";
  WebViewerElement["rotateClockwiseButton"] = "rotateClockwiseButton";
  WebViewerElement["menuOverlay"] = "menuOverlay";
  WebViewerElement["filePickerButton"] = "filePickerButton";
  WebViewerElement["fullScreenButton"] = "fullScreenButton";
  WebViewerElement["downloadButton"] = "downloadButton";
  WebViewerElement["printButton"] = "printButton";
  WebViewerElement["pageNavOverlay"] = "pageNavOverlay";
  WebViewerElement["insertBlankPagePanelButton"] = "insertBlankPagePanelButton";
  WebViewerElement["insertUploadedPagePanelButton"] = "insertUploadedPagePanelButton";
  WebViewerElement["insertBlankPagePanel"] = "insertBlankPagePanel";
  WebViewerElement["toolsOverlay"] = "toolsOverlay";
  WebViewerElement["searchOverlay"] = "searchOverlay";
  WebViewerElement["annotationPopup"] = "annotationPopup";
  WebViewerElement["applyWatermark"] = "applyWatermark";
  WebViewerElement["annotationCommentButton"] = "annotationCommentButton";
  WebViewerElement["annotationStyleEditButton"] = "annotationStyleEditButton";
  WebViewerElement["annotationDeleteButton"] = "annotationDeleteButton";
  WebViewerElement["annotationCropButton"] = "annotationCropButton";
  WebViewerElement["annotationRedactButton"] = "annotationRedactButton";
  WebViewerElement["annotationGroupButton"] = "annotationGroupButton";
  WebViewerElement["annotationUngroupButton"] = "annotationUngroupButton";
  WebViewerElement["calibrateButton"] = "calibrateButton";
  WebViewerElement["linkButton"] = "linkButton";
  WebViewerElement["fileAttachmentDownload"] = "fileAttachmentDownload";
  WebViewerElement["annotationStylePopup"] = "annotationStylePopup";
  WebViewerElement["toolStylePopup"] = "toolStylePopup";
  WebViewerElement["stylePopup"] = "stylePopup";
  WebViewerElement["colorPalette"] = "colorPalette";
  WebViewerElement["opacitySlider"] = "opacitySlider";
  WebViewerElement["textPopup"] = "textPopup";
  WebViewerElement["copyTextButton"] = "copyTextButton";
  WebViewerElement["textHighlightToolButton"] = "textHighlightToolButton";
  WebViewerElement["textUnderlineToolButton"] = "textUnderlineToolButton";
  WebViewerElement["textSquigglyToolButton"] = "textSquigglyToolButton";
  WebViewerElement["textStrikeoutToolButton"] = "textStrikeoutToolButton";
  WebViewerElement["contextMenuPopup"] = "contextMenuPopup";
  WebViewerElement["signatureModal"] = "signatureModal";
  WebViewerElement["signatureModalCloseButton"] = "signatureModalCloseButton";
  WebViewerElement["inkSignaturePanelButton"] = "inkSignaturePanelButton";
  WebViewerElement["textSignaturePanelButton"] = "textSignaturePanelButton";
  WebViewerElement["imageSignaturePanelButton"] = "imageSignaturePanelButton";
  WebViewerElement["printModal"] = "printModal";
  WebViewerElement["loadingModal"] = "loadingModal";
  WebViewerElement["errorModal"] = "errorModal";
  WebViewerElement["passwordModal"] = "passwordModal";
  WebViewerElement["progressModal"] = "progressModal";
  WebViewerElement["toolbarGroupView"] = "toolbarGroup-View";
  WebViewerElement["toolbarGroupAnnotate"] = "toolbarGroup-Annotate";
  WebViewerElement["toolbarGroupShapes"] = "toolbarGroup-Shapes";
  WebViewerElement["toolbarGroupInsert"] = "toolbarGroup-Insert";
  WebViewerElement["toolbarGroupMeasure"] = "toolbarGroup-Measure";
  WebViewerElement["toolbarGroupEdit"] = "toolbarGroup-Edit";
  WebViewerElement["cropToolGroupButton"] = "cropToolGroupButton";
  WebViewerElement["redactionToolGroupButton"] = "redactionToolGroupButton";
  WebViewerElement["ellipseToolGroupButton"] = "ellipseToolGroupButton";
  WebViewerElement["polygonToolGroupButton"] = "polygonToolGroupButton";
  WebViewerElement["polygonCloudToolGroupButton"] = "polygonCloudToolGroupButton";
  WebViewerElement["lineToolGroupButton"] = "lineToolGroupButton";
  WebViewerElement["polyLineToolGroupButton"] = "polyLineToolGroupButton";
  WebViewerElement["arrowToolGroupButton"] = "arrowToolGroupButton";
  WebViewerElement["distanceToolGroupButton"] = "distanceToolGroupButton";
  WebViewerElement["perimeterToolGroupButton"] = "perimeterToolGroupButton";
  WebViewerElement["areaToolGroupButton"] = "areaToolGroupButton";
  WebViewerElement["ellipseAreaToolGroupButton"] = "ellipseAreaToolGroupButton";
  WebViewerElement["rectangleAreaToolGroupButton"] = "rectangleAreaToolGroupButton";
  WebViewerElement["countToolGroupButton"] = "countToolGroupButton";
  WebViewerElement["ribbons"] = "ribbons";
  WebViewerElement["richTextPopup"] = "richTextPopup";
  WebViewerElement["signatureModalClearButton"] = "signatureModalClearButton";
  WebViewerElement["signatureModalSignButton"] = "signatureModalSignButton";
  WebViewerElement["notePopupState"] = "notePopupState";
  WebViewerElement["themeChangeButton"] = "themeChangeButton";
  WebViewerElement["richTextFormats"] = "richTextFormats";
  WebViewerElement["richTextBoldButton"] = "richTextBoldButton";
  WebViewerElement["richTextItalicButton"] = "richTextItalicButton";
  WebViewerElement["richTextUnderlineButton"] = "richTextUnderlineButton";
  WebViewerElement["richTextStrikeButton"] = "richTextStrikeButton";
  WebViewerElement["signaturePanelButton"] = "signaturePanelButton";
  WebViewerElement["addNewOutlineButtonContainer"] = "addNewOutlineButtonContainer";
  WebViewerElement["editOutlineButton"] = "editOutlineButton";
  WebViewerElement["thumbRotateCounterClockwise"] = "thumbRotateCounterClockwise";
  WebViewerElement["thumbDelete"] = "thumbDelete";
  WebViewerElement["thumbRotateClockwise"] = "thumbRotateClockwise";
  WebViewerElement["thumbMultiDelete"] = "thumbMultiDelete";
  WebViewerElement["thumbMultiRotate"] = "thumbMultiRotate";
  WebViewerElement["thumbExtract"] = "thumbExtract";
  WebViewerElement["pageAdditionalControlsHeader"] = "pageAdditionalControlsHeader";
  WebViewerElement["moveToTop"] = "moveToTop";
  WebViewerElement["moveToBottom"] = "moveToBottom";
  WebViewerElement["pageRotationHeader"] = "pageRotationHeader";
  WebViewerElement["rotatePageClockwise"] = "rotatePageClockwise";
  WebViewerElement["rotatePageCounterClockwise"] = "rotatePageCounterClockwise";
  WebViewerElement["pageInsertionHeader"] = "pageInsertionHeader";
  WebViewerElement["insertPageAbove"] = "insertPageAbove";
  WebViewerElement["insertPageBelow"] = "insertPageBelow";
  WebViewerElement["pageManipulationHeader"] = "pageManipulationHeader";
  WebViewerElement["replacePage"] = "replacePage";
  WebViewerElement["extractPage"] = "extractPage";
  WebViewerElement["deletePage"] = "deletePage";
  WebViewerElement["thumbnailsControlRotatePopupTrigger"] = "thumbnailsControlRotatePopupTrigger";
  WebViewerElement["thumbnailsControlInsertPopupTrigger"] = "thumbnailsControlInsertPopupTrigger";
  WebViewerElement["thumbnailsControlInsertAbove"] = "thumbnailsControlInsertAbove";
  WebViewerElement["thumbnailsControlInsertBelow"] = "thumbnailsControlInsertBelow";
  WebViewerElement["thumbnailsControlReplace"] = "thumbnailsControlReplace";
  WebViewerElement["thumbnailsControlExtract"] = "thumbnailsControlExtract";
  WebViewerElement["thumbnailsControlDelete"] = "thumbnailsControlDelete";
  WebViewerElement["thumbnailsControlManipulatePopupTrigger"] = "thumbnailsControlManipulatePopupTrigger";
  WebViewerElement["moreButton"] = "moreButton";
  WebViewerElement["toggleCompareModeButton"] = "toggleCompareModeButton";
  WebViewerElement["multiStateButton"] = "multiStateButton";
  WebViewerElement["multiGroupButton"] = "multiGroupButton";
  WebViewerElement["markInsertTextToolButton"] = "markInsertTextToolButton";
  WebViewerElement["markReplaceTextToolButton"] = "markReplaceTextToolButton";
  WebViewerElement["addReplyAttachmentButton"] = "addReplyAttachmentButton";
})(WebViewerElement || (WebViewerElement = {}));
const allWebViewerElements = Object.values(WebViewerElement);
const defaultWebViewerElements = [
  WebViewerElement.header,
  WebViewerElement.panToolButton,
  WebViewerElement.selectToolButton,
  WebViewerElement.zoomInButton,
  WebViewerElement.zoomOutButton,
  WebViewerElement.zoomOverlayButton,
  WebViewerElement.searchButton,
  WebViewerElement.searchOverlay,
  WebViewerElement.searchPanel,
  WebViewerElement.printModal,
  WebViewerElement.passwordModal,
  WebViewerElement.textPopup,
  WebViewerElement.contextMenuPopup,
  WebViewerElement.applyWatermark,
  WebViewerElement.viewControlsButton,
  WebViewerElement.moreButton
];
const viewControlsDropdown = [
  WebViewerElement.copyTextButton,
  WebViewerElement.viewControlsButton,
  WebViewerElement.viewControlsOverlay,
  WebViewerElement.continuousPageTransitionButton,
  WebViewerElement.defaultPageTransitionButton,
  WebViewerElement.rotateClockwiseButton,
  WebViewerElement.rotateCounterClockwiseButton,
  WebViewerElement.singleLayoutButton,
  WebViewerElement.doubleLayoutButton,
  WebViewerElement.coverLayoutButton,
];
const cogMenu = [
  WebViewerElement.menuButton,
  WebViewerElement.menuOverlay,
  WebViewerElement.downloadButton,
  WebViewerElement.fullScreenButton,
];
var HotKeysToDisable;
(function (HotKeysToDisable) {
  HotKeysToDisable["A"] = "a";
  HotKeysToDisable["C"] = "c";
  HotKeysToDisable["O"] = "o";
  HotKeysToDisable["E"] = "e";
  HotKeysToDisable["F"] = "f";
  HotKeysToDisable["L"] = "l";
  HotKeysToDisable["R"] = "r";
  HotKeysToDisable["S"] = "s";
  HotKeysToDisable["G"] = "g";
  HotKeysToDisable["T"] = "t";
  HotKeysToDisable["H"] = "h";
  HotKeysToDisable["I"] = "i";
  HotKeysToDisable["N"] = "n";
  HotKeysToDisable["K"] = "k";
  HotKeysToDisable["U"] = "u";
  HotKeysToDisable["Q"] = "q";
  HotKeysToDisable["CTRL_P"] = "ctrl+P";
  HotKeysToDisable["COMMAND_P"] = "command+P";
})(HotKeysToDisable || (HotKeysToDisable = {}));
var PdfTronFeature$1;
(function (PdfTronFeature) {
  PdfTronFeature["ThumbnailMerging"] = "ThumbnailMerging";
  PdfTronFeature["ThumbnailReordering"] = "ThumbnailReordering";
  PdfTronFeature["MultipleViewerMerging"] = "MultipleViewerMerging";
  PdfTronFeature["OutlineEditing"] = "OutlineEditing";
})(PdfTronFeature$1 || (PdfTronFeature$1 = {}));

var Locale;
(function (Locale) {
  Locale["en_au"] = "en_au";
  Locale["en_ca"] = "en_ca";
  Locale["en_gb"] = "en_gb";
  Locale["en"] = "en";
  Locale["es"] = "es";
  Locale["fr"] = "fr";
  Locale["pt_br"] = "pt_br";
})(Locale || (Locale = {}));
var SeparatorButton;
(function (SeparatorButton) {
  SeparatorButton["divider"] = "divider";
  SeparatorButton["spacer"] = "spacer";
})(SeparatorButton || (SeparatorButton = {}));
var PdfTronFeature;
(function (PdfTronFeature) {
  PdfTronFeature["ThumbnailMerging"] = "ThumbnailMerging";
  PdfTronFeature["ThumbnailReordering"] = "ThumbnailReordering";
  PdfTronFeature["MultipleViewerMerging"] = "MultipleViewerMerging";
  PdfTronFeature["OutlineEditing"] = "OutlineEditing";
})(PdfTronFeature || (PdfTronFeature = {}));

const translations_en_AU = {
	"CommonFileViewer.PreviewNotAvailable": "Preview not available for this type.",
	"CommonFileViewer.Print": "Print",
	"CommonFileViewer.Close": "Close",
	"CommonFileViewer.Download": "Download",
	"CommonFileViewer.PrintModal.AddWatermark": "Add Watermark",
	"CommonFileViewer.PrintModal.IncludeAnnotations": "Include annotations",
	"CommonFileViewer.PrintModal.IncludeComments": "Include comments",
	"CommonFileViewer.PrintModal.PrintOptions": "Print Options",
	"CommonFileViewer.PrintModal.PrintWarningMessage": "##DocumentName## is being prepared to print. (##Percentage##% complete)",
	"CommonFileViewer.WatermarkModal.Add": "Add",
	"CommonFileViewer.WatermarkModal.BottomCenter": "Bottom Centre",
	"CommonFileViewer.WatermarkModal.BottomLeft": "Bottom Left",
	"CommonFileViewer.WatermarkModal.BottomRight": "Bottom Right",
	"CommonFileViewer.WatermarkModal.Cancel": "Cancel",
	"CommonFileViewer.WatermarkModal.Center": "Centre",
	"CommonFileViewer.WatermarkModal.Font": "Font",
	"CommonFileViewer.WatermarkModal.FontStyle": "Font style",
	"CommonFileViewer.WatermarkModal.Opacity": "Opacity",
	"CommonFileViewer.WatermarkModal.Placement": "Placement",
	"CommonFileViewer.WatermarkModal.RestoreDefaultSettings": "Restore default settings",
	"CommonFileViewer.WatermarkModal.Size": "Size",
	"CommonFileViewer.WatermarkModal.Text": "Text",
	"CommonFileViewer.WatermarkModal.TopCenter": "Top Centre",
	"CommonFileViewer.WatermarkModal.TopLeft": "Top Left",
	"CommonFileViewer.WatermarkModal.TopRight": "Top Right",
	"CommonFileViewer.Buttons.Previous": "Previous",
	"CommonFileViewer.Buttons.Next": "Next",
	"CommonFileViewer.DocumentIsInvalid": "Preview is not available because there may be a problem with the document.",
	"CommonFileViewer.Header.Approve": "Approve",
	"CommonFileViewer.Header.Combine": "Combine PDFs",
	"CommonFileViewer.Header.Copy": "Copy",
	"CommonFileViewer.Header.Delete": "Delete",
	"CommonFileViewer.Header.Manage": "Manage",
	"CommonFileViewer.Header.Move": "Move",
	"CommonFileViewer.Header.Open": "Open",
	"CommonFileViewer.Header.Rename": "Rename",
	"CommonFileViewer.Header.Send": "Send",
	"CommonFileViewer.Header.Unlock": "Unlock",
	"CommonFileViewer.Header.Protect": "Protect",
	"CommonFileViewer.Header.Unprotect": "Unprotect",
	"CommonFileViewer.Header.RemoveLock": "Remove Lock",
	"CommonFileViewer.Header.Properties": "Properties",
	"CommonFileViewer.Header.InsertScan": "Insert scan",
	"CommonFileViewer.Alert.DocumentLocked": "This document is locked and cannot be edited.",
	"CommonFileViewer.Alert.ESignedWontUnlock": "This document contains an eSignature and cannot be unlocked."
};

const translations_en_CA = {
	"CommonFileViewer.PreviewNotAvailable": "Preview not available for this type.",
	"CommonFileViewer.Print": "Print",
	"CommonFileViewer.Close": "Close",
	"CommonFileViewer.Download": "Download",
	"CommonFileViewer.PrintModal.AddWatermark": "Add Watermark",
	"CommonFileViewer.PrintModal.IncludeAnnotations": "Include annotations",
	"CommonFileViewer.PrintModal.IncludeComments": "Include comments",
	"CommonFileViewer.PrintModal.PrintOptions": "Print Options",
	"CommonFileViewer.PrintModal.PrintWarningMessage": "##DocumentName## is being prepared to print. (##Percentage##% complete)",
	"CommonFileViewer.WatermarkModal.Add": "Add",
	"CommonFileViewer.WatermarkModal.BottomCenter": "Bottom Centre",
	"CommonFileViewer.WatermarkModal.BottomLeft": "Bottom Left",
	"CommonFileViewer.WatermarkModal.BottomRight": "Bottom Right",
	"CommonFileViewer.WatermarkModal.Cancel": "Cancel",
	"CommonFileViewer.WatermarkModal.Center": "Centre",
	"CommonFileViewer.WatermarkModal.Font": "Font",
	"CommonFileViewer.WatermarkModal.FontStyle": "Font style",
	"CommonFileViewer.WatermarkModal.Opacity": "Opacity",
	"CommonFileViewer.WatermarkModal.Placement": "Placement",
	"CommonFileViewer.WatermarkModal.RestoreDefaultSettings": "Restore default settings",
	"CommonFileViewer.WatermarkModal.Size": "Size",
	"CommonFileViewer.WatermarkModal.Text": "Text",
	"CommonFileViewer.WatermarkModal.TopCenter": "Top Centre",
	"CommonFileViewer.WatermarkModal.TopLeft": "Top Left",
	"CommonFileViewer.WatermarkModal.TopRight": "Top Right",
	"CommonFileViewer.Buttons.Previous": "Previous",
	"CommonFileViewer.Buttons.Next": "Next",
	"CommonFileViewer.DocumentIsInvalid": "Preview is not available because there may be a problem with the document.",
	"CommonFileViewer.Header.Approve": "Approve",
	"CommonFileViewer.Header.Combine": "Combine PDFs",
	"CommonFileViewer.Header.Copy": "Copy",
	"CommonFileViewer.Header.Delete": "Delete",
	"CommonFileViewer.Header.Manage": "Manage",
	"CommonFileViewer.Header.Move": "Move",
	"CommonFileViewer.Header.Open": "Open",
	"CommonFileViewer.Header.Rename": "Rename",
	"CommonFileViewer.Header.Send": "Send",
	"CommonFileViewer.Header.Unlock": "Unlock",
	"CommonFileViewer.Header.Protect": "Protect",
	"CommonFileViewer.Header.Unprotect": "Unprotect",
	"CommonFileViewer.Header.RemoveLock": "Remove Lock",
	"CommonFileViewer.Header.Properties": "Properties",
	"CommonFileViewer.Header.InsertScan": "Insert scan",
	"CommonFileViewer.Alert.DocumentLocked": "This document is locked and cannot be edited.",
	"CommonFileViewer.Alert.ESignedWontUnlock": "This document contains an eSignature and cannot be unlocked."
};

const translations_en_GB = {
	"CommonFileViewer.PreviewNotAvailable": "Preview not available for this type.",
	"CommonFileViewer.Print": "Print",
	"CommonFileViewer.Close": "Close",
	"CommonFileViewer.Download": "Download",
	"CommonFileViewer.PrintModal.AddWatermark": "Add Watermark",
	"CommonFileViewer.PrintModal.IncludeAnnotations": "Include annotations",
	"CommonFileViewer.PrintModal.IncludeComments": "Include comments",
	"CommonFileViewer.PrintModal.PrintOptions": "Print Options",
	"CommonFileViewer.PrintModal.PrintWarningMessage": "##DocumentName## is being prepared to print. (##Percentage##% complete)",
	"CommonFileViewer.WatermarkModal.Add": "Add",
	"CommonFileViewer.WatermarkModal.BottomCenter": "Bottom Centre",
	"CommonFileViewer.WatermarkModal.BottomLeft": "Bottom Left",
	"CommonFileViewer.WatermarkModal.BottomRight": "Bottom Right",
	"CommonFileViewer.WatermarkModal.Cancel": "Cancel",
	"CommonFileViewer.WatermarkModal.Center": "Centre",
	"CommonFileViewer.WatermarkModal.Font": "Font",
	"CommonFileViewer.WatermarkModal.FontStyle": "Font style",
	"CommonFileViewer.WatermarkModal.Opacity": "Opacity",
	"CommonFileViewer.WatermarkModal.Placement": "Placement",
	"CommonFileViewer.WatermarkModal.RestoreDefaultSettings": "Restore default settings",
	"CommonFileViewer.WatermarkModal.Size": "Size",
	"CommonFileViewer.WatermarkModal.Text": "Text",
	"CommonFileViewer.WatermarkModal.TopCenter": "Top Centre",
	"CommonFileViewer.WatermarkModal.TopLeft": "Top Left",
	"CommonFileViewer.WatermarkModal.TopRight": "Top Right",
	"CommonFileViewer.Buttons.Previous": "Previous",
	"CommonFileViewer.Buttons.Next": "Next",
	"CommonFileViewer.DocumentIsInvalid": "Preview is not available because there may be a problem with the document.",
	"CommonFileViewer.Header.Approve": "Approve",
	"CommonFileViewer.Header.Combine": "Combine PDFs",
	"CommonFileViewer.Header.Copy": "Copy",
	"CommonFileViewer.Header.Delete": "Delete",
	"CommonFileViewer.Header.Manage": "Manage",
	"CommonFileViewer.Header.Move": "Move",
	"CommonFileViewer.Header.Open": "Open",
	"CommonFileViewer.Header.Rename": "Rename",
	"CommonFileViewer.Header.Send": "Send",
	"CommonFileViewer.Header.Unlock": "Unlock",
	"CommonFileViewer.Header.Protect": "Protect",
	"CommonFileViewer.Header.Unprotect": "Unprotect",
	"CommonFileViewer.Header.RemoveLock": "Remove Lock",
	"CommonFileViewer.Header.Properties": "Properties",
	"CommonFileViewer.Header.InsertScan": "Insert scan",
	"CommonFileViewer.Alert.DocumentLocked": "This document is locked and cannot be edited.",
	"CommonFileViewer.Alert.ESignedWontUnlock": "This document contains an eSignature and cannot be unlocked."
};

const translations_en_US = {
	"CommonFileViewer.PreviewNotAvailable": "Preview not available for this type.",
	"CommonFileViewer.Print": "Print",
	"CommonFileViewer.Close": "Close",
	"CommonFileViewer.Download": "Download",
	"CommonFileViewer.PrintModal.AddWatermark": "Add Watermark",
	"CommonFileViewer.PrintModal.IncludeAnnotations": "Include annotations",
	"CommonFileViewer.PrintModal.IncludeComments": "Include comments",
	"CommonFileViewer.PrintModal.PrintOptions": "Print Options",
	"CommonFileViewer.PrintModal.PrintWarningMessage": "##DocumentName## is being prepared to print. (##Percentage##% complete)",
	"CommonFileViewer.WatermarkModal.Add": "Add",
	"CommonFileViewer.WatermarkModal.BottomCenter": "Bottom Center",
	"CommonFileViewer.WatermarkModal.BottomLeft": "Bottom Left",
	"CommonFileViewer.WatermarkModal.BottomRight": "Bottom Right",
	"CommonFileViewer.WatermarkModal.Cancel": "Cancel",
	"CommonFileViewer.WatermarkModal.Center": "Center",
	"CommonFileViewer.WatermarkModal.Font": "Font",
	"CommonFileViewer.WatermarkModal.FontStyle": "Font style",
	"CommonFileViewer.WatermarkModal.Opacity": "Opacity",
	"CommonFileViewer.WatermarkModal.Placement": "Placement",
	"CommonFileViewer.WatermarkModal.RestoreDefaultSettings": "Restore default settings",
	"CommonFileViewer.WatermarkModal.Size": "Size",
	"CommonFileViewer.WatermarkModal.Text": "Text",
	"CommonFileViewer.WatermarkModal.TopCenter": "Top Center",
	"CommonFileViewer.WatermarkModal.TopLeft": "Top Left",
	"CommonFileViewer.WatermarkModal.TopRight": "Top Right",
	"CommonFileViewer.Buttons.Previous": "Previous",
	"CommonFileViewer.Buttons.Next": "Next",
	"CommonFileViewer.DocumentIsInvalid": "Preview is not available because there may be a problem with the document.",
	"CommonFileViewer.Header.Approve": "Approve",
	"CommonFileViewer.Header.Combine": "Combine PDFs",
	"CommonFileViewer.Header.Copy": "Copy",
	"CommonFileViewer.Header.Delete": "Delete",
	"CommonFileViewer.Header.Manage": "Manage",
	"CommonFileViewer.Header.Move": "Move",
	"CommonFileViewer.Header.Open": "Open",
	"CommonFileViewer.Header.Rename": "Rename",
	"CommonFileViewer.Header.Send": "Send",
	"CommonFileViewer.Header.Unlock": "Unlock",
	"CommonFileViewer.Header.Protect": "Protect",
	"CommonFileViewer.Header.Unprotect": "Unprotect",
	"CommonFileViewer.Header.RemoveLock": "Remove Lock",
	"CommonFileViewer.Header.Properties": "Properties",
	"CommonFileViewer.Header.InsertScan": "Insert scan",
	"CommonFileViewer.Alert.DocumentLocked": "This document is locked and cannot be edited.",
	"CommonFileViewer.Alert.ESignedWontUnlock": "This document contains an eSignature and cannot be unlocked."
};

const translations_es_AR = {
	"CommonFileViewer.PreviewNotAvailable": "Vista previa no disponible para este tipo de archivo.",
	"CommonFileViewer.Print": "Imprimir",
	"CommonFileViewer.Close": "Cerrar",
	"CommonFileViewer.Download": "Descargar",
	"CommonFileViewer.PrintModal.AddWatermark": "Añadir marca de agua",
	"CommonFileViewer.PrintModal.IncludeAnnotations": "Incluir anotaciones",
	"CommonFileViewer.PrintModal.IncludeComments": "Incluir comentarios",
	"CommonFileViewer.PrintModal.PrintOptions": "Opciones de impresión",
	"CommonFileViewer.PrintModal.PrintWarningMessage": "##DocumentName## preparando para imprimir. (##Percentage##% completado)",
	"CommonFileViewer.WatermarkModal.Add": "Agregar",
	"CommonFileViewer.WatermarkModal.BottomCenter": "Abajo centrado",
	"CommonFileViewer.WatermarkModal.BottomLeft": "Abajo izquierda",
	"CommonFileViewer.WatermarkModal.BottomRight": "Abajo derecha",
	"CommonFileViewer.WatermarkModal.Cancel": "Cancelar",
	"CommonFileViewer.WatermarkModal.Center": "Centrado",
	"CommonFileViewer.WatermarkModal.Font": "Fuente",
	"CommonFileViewer.WatermarkModal.FontStyle": "Estilo de fuente",
	"CommonFileViewer.WatermarkModal.Opacity": "Opacidad",
	"CommonFileViewer.WatermarkModal.Placement": "Asignación",
	"CommonFileViewer.WatermarkModal.RestoreDefaultSettings": "Restaurar ajustes por defecto",
	"CommonFileViewer.WatermarkModal.Size": "Tamaño",
	"CommonFileViewer.WatermarkModal.Text": "Texto",
	"CommonFileViewer.WatermarkModal.TopCenter": "Arriba centrado",
	"CommonFileViewer.WatermarkModal.TopLeft": "Arriba izquierda",
	"CommonFileViewer.WatermarkModal.TopRight": "Arriba derecha",
	"CommonFileViewer.Buttons.Previous": "Anterior",
	"CommonFileViewer.Buttons.Next": "Siguiente",
	"CommonFileViewer.DocumentIsInvalid": "La vista previa no está disponible porque puede haber un problema con el documento.",
	"CommonFileViewer.Header.Approve": "Aprobar",
	"CommonFileViewer.Header.Combine": "Combinar PDFs",
	"CommonFileViewer.Header.Copy": "Copiar",
	"CommonFileViewer.Header.Delete": "Eliminar",
	"CommonFileViewer.Header.Manage": "Administrar",
	"CommonFileViewer.Header.Move": "Mover",
	"CommonFileViewer.Header.Open": "Abrir",
	"SCommonFileViewer.Header.Print": "Imprimir",
	"CommonFileViewer.Header.Rename": "Cambiar Nombre",
	"CommonFileViewer.Header.Send": "Enviar",
	"CommonFileViewer.Header.Unlock": "Desbloquear",
	"CommonFileViewer.Header.Protect": "Proteger",
	"CommonFileViewer.Header.Unprotect": "Desproteger",
	"CommonFileViewer.Header.RemoveLock": "Desbloquear",
	"CommonFileViewer.Header.Properties": "Propiedades",
	"CommonFileViewer.Alert.DocumentLocked": "Este documento está bloqueado y no se puede editar.",
	"CommonFileViewer.Alert.ESignedWontUnlock": "Este documento contiene una firma electrónica y no se puede desbloquear.",
	"CommonFileViewer.Header.InsertScan": "Insertar escaneo"
};

const translations_fr_CA = {
	"CommonFileViewer.PreviewNotAvailable": "L'aperçu n'est pas disponible pour ce type de fichier.",
	"CommonFileViewer.Print": "Imprimer",
	"CommonFileViewer.Close": "Fermer",
	"CommonFileViewer.Download": "Télécharger",
	"CommonFileViewer.PrintModal.AddWatermark": "Ajouter un filigrane",
	"CommonFileViewer.PrintModal.IncludeAnnotations": "Inclure les annotations",
	"CommonFileViewer.PrintModal.IncludeComments": "Inclure les commentaires",
	"CommonFileViewer.PrintModal.PrintOptions": "Options d'impression",
	"CommonFileViewer.PrintModal.PrintWarningMessage": "##DocumentName## est en cours de préparation pour l'impression. (complété à ##Percentage##%)",
	"CommonFileViewer.WatermarkModal.Add": "Ajouter",
	"CommonFileViewer.WatermarkModal.BottomCenter": "En bas au centre",
	"CommonFileViewer.WatermarkModal.BottomLeft": "En bas à gauche",
	"CommonFileViewer.WatermarkModal.BottomRight": "En bas à droite",
	"CommonFileViewer.WatermarkModal.Cancel": "Annuler",
	"CommonFileViewer.WatermarkModal.Center": "Centre",
	"CommonFileViewer.WatermarkModal.Font": "Police de caractères",
	"CommonFileViewer.WatermarkModal.FontStyle": "Style de police",
	"CommonFileViewer.WatermarkModal.Opacity": "Opacité",
	"CommonFileViewer.WatermarkModal.Placement": "Placement",
	"CommonFileViewer.WatermarkModal.RestoreDefaultSettings": "Rétablir les réglages par défaut",
	"CommonFileViewer.WatermarkModal.Size": "Taille",
	"CommonFileViewer.WatermarkModal.Text": "Texte",
	"CommonFileViewer.WatermarkModal.TopCenter": "En haut au centre",
	"CommonFileViewer.WatermarkModal.TopLeft": "En haut à gauche",
	"CommonFileViewer.WatermarkModal.TopRight": "En haut à droite",
	"CommonFileViewer.Buttons.Previous": "Précédent",
	"CommonFileViewer.Buttons.Next": "Suivant",
	"CommonFileViewer.DocumentIsInvalid": "L'aperçu n'est pas disponible car il pourrait y avoir un problème avec le document.",
	"CommonFileViewer.Header.Approve": "Approuver",
	"CommonFileViewer.Header.Combine": "Combiner PDFs",
	"CommonFileViewer.Header.Copy": "Copier",
	"CommonFileViewer.Header.Delete": "Supprimer",
	"CommonFileViewer.Header.Manage": "Gérer",
	"CommonFileViewer.Header.Move": "Déplacer",
	"CommonFileViewer.Header.Open": "Ouvrir",
	"CommonFileViewer.Header.Print": "Imprimer",
	"CommonFileViewer.Header.Rename": "Renommer",
	"CommonFileViewer.Header.Send": "Envoyer",
	"CommonFileViewer.Header.Unlock": "Déverrouiller",
	"CommonFileViewer.Header.Protect": "Protéger",
	"CommonFileViewer.Header.Unprotect": "Annuler la protection",
	"CommonFileViewer.Header.RemoveLock": "Retirer le verrou",
	"CommonFileViewer.Header.Properties": "Propriétés",
	"CommonFileViewer.Alert.DocumentLocked": "Ce document est verrouillé et ne peut pas être modifié.",
	"CommonFileViewer.Alert.ESignedWontUnlock": "Ce document contient une signature électronique et ne peut pas être déverrouillé.",
	"CommonFileViewer.Header.InsertScan": "Insérer une numérisation"
};

const translations_pt_BR = {
	"CommonFileViewer.PreviewNotAvailable": "Visualização não disponível para este tipo de arquivo.",
	"CommonFileViewer.Print": "Imprimir",
	"CommonFileViewer.Close": "Fechar",
	"CommonFileViewer.Download": "Baixar",
	"CommonFileViewer.PrintModal.AddWatermark": "Adicionar Marca D'água",
	"CommonFileViewer.PrintModal.IncludeAnnotations": "Incluir anotações",
	"CommonFileViewer.PrintModal.IncludeComments": "Incluir comentários",
	"CommonFileViewer.PrintModal.PrintOptions": "Opções de Impressão",
	"CommonFileViewer.PrintModal.PrintWarningMessage": "##DocumentName## está sendo preparado para impressão. (##Percentage##% concluída)",
	"CommonFileViewer.WatermarkModal.Add": "Adicionar",
	"CommonFileViewer.WatermarkModal.BottomCenter": "Centro Inferior",
	"CommonFileViewer.WatermarkModal.BottomLeft": "Inferior Esquerdo",
	"CommonFileViewer.WatermarkModal.BottomRight": "Inferior Direito",
	"CommonFileViewer.WatermarkModal.Cancel": "Cancelar",
	"CommonFileViewer.WatermarkModal.Center": "Centro",
	"CommonFileViewer.WatermarkModal.Font": "Fonte",
	"CommonFileViewer.WatermarkModal.FontStyle": "Estilo de fonte",
	"CommonFileViewer.WatermarkModal.Opacity": "Opacidade",
	"CommonFileViewer.WatermarkModal.Placement": "Posicionamento",
	"CommonFileViewer.WatermarkModal.RestoreDefaultSettings": "Restaurar configurações padrão",
	"CommonFileViewer.WatermarkModal.Size": "Tamanho",
	"CommonFileViewer.WatermarkModal.Text": "Texto",
	"CommonFileViewer.WatermarkModal.TopCenter": "Centro Superior",
	"CommonFileViewer.WatermarkModal.TopLeft": "Superior Esquerdo",
	"CommonFileViewer.WatermarkModal.TopRight": "Superior Direito",
	"CommonFileViewer.Buttons.Previous": "Voltar",
	"CommonFileViewer.Buttons.Next": "Avançar",
	"CommonFileViewer.DocumentIsInvalid": "A visualização não está disponível porque pode haver um problema com o documento.",
	"CommonFileViewer.Header.Approve": "Aprovar",
	"CommonFileViewer.Header.Combine": "Combinar PDFs",
	"CommonFileViewer.Header.Copy": "Copiar",
	"CommonFileViewer.Header.Delete": "Excluir",
	"CommonFileViewer.Header.Manage": "Gerenciar",
	"CommonFileViewer.Header.Move": "Mover",
	"CommonFileViewer.Header.Open": "Abrir",
	"CommonFileViewer.Header.Print": "Imprimir",
	"CommonFileViewer.Header.Rename": "Renomear",
	"CommonFileViewer.Header.Send": "Enviar",
	"CommonFileViewer.Header.Unlock": "Desbloquear",
	"CommonFileViewer.Header.Protect": "Proteger",
	"CommonFileViewer.Header.Unprotect": "Desproteger",
	"CommonFileViewer.Header.RemoveLock": "Remover Bloqueio",
	"CommonFileViewer.Header.Properties": "Propriedades",
	"CommonFileViewer.Alert.DocumentLocked": "Este documento está bloqueado e não pode ser editado.",
	"CommonFileViewer.Alert.ESignedWontUnlock": "Este documento contém uma assinatura eletrônica e não pode ser desbloqueado.",
	"CommonFileViewer.Header.InsertScan": "Inserir digitalização"
};

function configureTranslations() {
  addKeys(translations_en_AU, 'en-AU');
  addKeys(translations_en_CA, 'en-CA');
  addKeys(translations_en_GB, 'en-GB');
  addKeys(translations_en_US, 'en-US');
  addKeys(translations_es_AR, 'es-AR');
  addKeys(translations_fr_CA, 'fr-CA');
  addKeys(translations_pt_BR, 'pt-BR');
}
function getStrings() {
  const strings = {};
  Object.values(TranslationKey).forEach((key) => {
    strings[key] = instantTranslate(key);
  });
  return strings;
}
function setLanguage(locale) {
  const languageCode = blueLanguageCodes[locale];
  const currentLanguageCode = getCurrentLanguage();
  if (currentLanguageCode !== languageCode) {
    changeLanguage(languageCode);
  }
}
var TranslationKey;
(function (TranslationKey) {
  TranslationKey["PreviewNotAvailable"] = "CommonFileViewer.PreviewNotAvailable";
  TranslationKey["Print"] = "CommonFileViewer.Print";
  TranslationKey["Close"] = "CommonFileViewer.Close";
  TranslationKey["Download"] = "CommonFileViewer.Download";
  TranslationKey["PreviousButtonTitle"] = "CommonFileViewer.Buttons.Previous";
  TranslationKey["NextButtonTitle"] = "CommonFileViewer.Buttons.Next";
  TranslationKey["AddWatermark"] = "CommonFileViewer.PrintModal.AddWatermark";
  TranslationKey["IncludeAnnotations"] = "CommonFileViewer.PrintModal.IncludeAnnotations";
  TranslationKey["IncludeComments"] = "CommonFileViewer.PrintModal.IncludeComments";
  TranslationKey["PrintOptions"] = "CommonFileViewer.PrintModal.PrintOptions";
  TranslationKey["PrintWarningMessage"] = "CommonFileViewer.PrintModal.PrintWarningMessage";
  TranslationKey["WatermarkModalAdd"] = "CommonFileViewer.WatermarkModal.Add";
  TranslationKey["WatermarkModalBottomCenter"] = "CommonFileViewer.WatermarkModal.BottomCenter";
  TranslationKey["WatermarkModalBottomLeft"] = "CommonFileViewer.WatermarkModal.BottomLeft";
  TranslationKey["WatermarkModalBottomRight"] = "CommonFileViewer.WatermarkModal.BottomRight";
  TranslationKey["WatermarkModalCancel"] = "CommonFileViewer.WatermarkModal.Cancel";
  TranslationKey["WatermarkModalCenter"] = "CommonFileViewer.WatermarkModal.Center";
  TranslationKey["WatermarkModalFont"] = "CommonFileViewer.WatermarkModal.Font";
  TranslationKey["WatermarkModalFontStyle"] = "CommonFileViewer.WatermarkModal.FontStyle";
  TranslationKey["WatermarkModalOpacity"] = "CommonFileViewer.WatermarkModal.Opacity";
  TranslationKey["WatermarkModalPlacement"] = "CommonFileViewer.WatermarkModal.Placement";
  TranslationKey["WatermarkModalRestoreDefaultSettings"] = "CommonFileViewer.WatermarkModal.RestoreDefaultSettings";
  TranslationKey["WatermarkModalSize"] = "CommonFileViewer.WatermarkModal.Size";
  TranslationKey["WatermarkModalText"] = "CommonFileViewer.WatermarkModal.Text";
  TranslationKey["WatermarkModalTopCenter"] = "CommonFileViewer.WatermarkModal.TopCenter";
  TranslationKey["WatermarkModalTopLeft"] = "CommonFileViewer.WatermarkModal.TopLeft";
  TranslationKey["WatermarkModalTopRight"] = "CommonFileViewer.WatermarkModal.TopRight";
  TranslationKey["DocumentIsInvalid"] = "CommonFileViewer.DocumentIsInvalid";
  TranslationKey["Approve"] = "CommonFileViewer.Header.Approve";
  TranslationKey["Copy"] = "CommonFileViewer.Header.Copy";
  TranslationKey["Delete"] = "CommonFileViewer.Header.Delete";
  TranslationKey["Manage"] = "CommonFileViewer.Header.Manage";
  TranslationKey["Move"] = "CommonFileViewer.Header.Move";
  TranslationKey["Open"] = "CommonFileViewer.Header.Open";
  TranslationKey["Rename"] = "CommonFileViewer.Header.Rename";
  TranslationKey["Send"] = "CommonFileViewer.Header.Send";
  TranslationKey["Unlock"] = "CommonFileViewer.Header.Unlock";
  TranslationKey["Properties"] = "CommonFileViewer.Header.Properties";
  TranslationKey["RemoveLock"] = "CommonFileViewer.Header.RemoveLock";
  TranslationKey["Unprotect"] = "CommonFileViewer.Header.Unprotect";
  TranslationKey["Protect"] = "CommonFileViewer.Header.Protect";
  TranslationKey["InsertScan"] = "CommonFileViewer.Header.InsertScan";
  TranslationKey["DocumentLocked"] = "CommonFileViewer.Alert.DocumentLocked";
  TranslationKey["ESignedDocumentWontUnlock"] = "CommonFileViewer.Alert.ESignedWontUnlock";
})(TranslationKey || (TranslationKey = {}));
const blueLanguageCodes = {
  [Locale.en_au]: 'en-AU',
  [Locale.en_ca]: 'en-CA',
  [Locale.en_gb]: 'en-GB',
  [Locale.en]: 'en-US',
  [Locale.es]: 'es-AR',
  [Locale.fr]: 'fr-CA',
  [Locale.pt_br]: 'pt-BR',
};

function includesExtension(extensions, name) {
  const dotIndex = name.lastIndexOf('.');
  const extension = name.substring(dotIndex + 1).toLocaleLowerCase();
  return extensions.includes(extension);
}
const webViewerClientSupported = ['pdf', 'xfdf', 'fdf', 'docx', 'xlsx', 'pptx', 'jpg', 'jpeg', 'png', 'jfif', 'xls'];
const isWebViewerClientSupported = includesExtension.bind(null, webViewerClientSupported);
const webViewerServerSupported = [
  'doc',
  'xls',
  'ppt',
  'pub',
  'dwg',
  'dxf',
  'dgn',
  'rvt',
  'bmp',
  'wmf',
  'emf',
  'gif',
  'jp2',
  'jpc',
  'rtf',
  'html',
  'msg',
  'eml',
  'txt',
  'xps',
  'xod',
  'xaml',
];
includesExtension.bind(null, webViewerServerSupported);

const pdftronLangToDateTimeFormat = {
  [Locale.en]: 'MM/DD/YYYY hh:mm A',
  [Locale.en_ca]: 'YYYY-MM-DD hh:mm A',
  [Locale.en_gb]: 'DD/MM/YYYY HH:mm',
  [Locale.fr]: 'YYYY-MM-DD HH:mm',
  [Locale.pt_br]: 'DD/MM/YYYY HH:mm',
  [Locale.es]: 'DD/MM/YYYY HH:mm',
  [Locale.en_au]: 'DD/MM/YYYY hh:mm A',
};
const pdftronLangToDateFnsDateTimeFormat = {
  [Locale.en]: 'MM/dd/yyyy hh:mm a',
  [Locale.en_ca]: 'yyyy-MM-dd hh:mm a',
  [Locale.en_gb]: 'dd/MM/yyyy HH:mm',
  [Locale.fr]: 'yyyy-MM-dd HH:mm',
  [Locale.pt_br]: 'dd/MM/yyyy HH:mm',
  [Locale.es]: 'dd/MM/yyyy HH:mm',
  [Locale.en_au]: 'dd/MM/yyyy hh:mm a',
};
function getDateTimeFormat(language) {
  return pdftronLangToDateTimeFormat[language];
}
function getDateFnDateTimeFormat(language) {
  return pdftronLangToDateFnsDateTimeFormat[language];
}

const webViewerDefaultZoom = 1.2;
const highestPrintQuality = 5;

var AlertType;
(function (AlertType) {
  AlertType["warning"] = "warning";
  AlertType["danger"] = "danger";
  AlertType["info"] = "info";
  AlertType["success"] = "success";
})(AlertType || (AlertType = {}));
var AlertLocation;
(function (AlertLocation) {
  AlertLocation["top"] = ".top-alerts-container";
  AlertLocation["bottom"] = ".bottom-alerts-container";
})(AlertLocation || (AlertLocation = {}));

function setUserDateTimeFormat(webViewer, locale) {
  const dateTimeFormat = getDateTimeFormat(locale);
  webViewer.UI.setNoteDateFormat(dateTimeFormat);
}
function customizeNotesDates(webViewer, locale) {
  const dateFormat = getDateFnDateTimeFormat(locale);
  webViewer.UI.dangerouslySetNoteTransformFunction((wrapper, state) => {
    const { annotation } = state;
    const markupAnnotation = annotation;
    const dateElement = wrapper.querySelector('.date-and-time');
    dateElement.textContent = markupAnnotation.DateCreated ? format(markupAnnotation.DateCreated, dateFormat) : '';
  });
}
function removeHeaderSeparatorItems(webViewer) {
  webViewer.UI.setHeaderItems(header => {
    const headerButtons = header.getItems();
    const visibleHeaderButtons = headerButtons.filter(function (x, index) {
      const previousElement = headerButtons[index - 1];
      // Keeping only the divider after free text tool.
      return (x.type !== SeparatorButton.divider ||
        (index > 0 && previousElement.dataElement == WebViewerElement.freeTextToolGroupButton));
    });
    const allHeaderButtons = [...visibleHeaderButtons];
    header.update(allHeaderButtons);
  });
}
function configureHotKeys(webViewer, options, printHandler) {
  for (const item of Object.values(HotKeysToDisable)) {
    webViewer.UI.hotkeys.off(item);
  }
  if (options.showHighlightTool) {
    webViewer.UI.hotkeys.on(webViewer.UI.hotkeys.Keys.H);
  }
  if (options.showFreeTextTool) {
    webViewer.UI.hotkeys.on(webViewer.UI.hotkeys.Keys.T);
  }
  if (options.enablePrintHotKey) {
    const printHotKeys = ['ctrl+P', 'command+P'];
    webViewer.UI.hotkeys.on(printHotKeys.join(', '), (event) => {
      event.preventDefault();
      if (printHandler) {
        printHandler();
      }
      if (document.fullscreenElement) {
        void document.exitFullscreen();
      }
    });
  }
}
function configureWebViewer(webViewer, options, hostElement, fileViewerStrings, isDocumentLoaded) {
  if (options.isCombineDocuments) {
    options.disabledElements = [WebViewerElement.searchButton, WebViewerElement.leftPanelButton, WebViewerElement.toggleNotesButton, WebViewerElement.selectToolButton, WebViewerElement.moreButton];
    options.showViewControlsDropdown = true;
  }
  const elementsToEnable = getEnabledElements(options);
  const elementsToDisable = allWebViewerElements.filter(el => !elementsToEnable.includes(el));
  webViewer.UI.disableElements(elementsToDisable);
  webViewer.UI.enableElements(elementsToEnable);
  if (options.locale) {
    webViewer.UI.setLanguage(options.locale);
    setLanguage(options.locale);
    setUserDateTimeFormat(webViewer, options.locale);
    customizeNotesDates(webViewer, options.locale);
  }
  webViewer.UI.setPrintQuality(highestPrintQuality);
  if ((options === null || options === void 0 ? void 0 : options.hideHeaderSeparators) || (options === null || options === void 0 ? void 0 : options.hideHeaderSeparators) === undefined) {
    removeHeaderSeparatorItems(webViewer);
  }
  removeAlerts(hostElement, AlertLocation.top);
  removeAlerts(hostElement, AlertLocation.bottom);
  if (options.isThumbnailsOnlyMode) {
    configureThumbnailsOnlyView(webViewer, options);
  }
  if (options.editable && options.readonly && isDocumentLoaded) {
    addClosableAlert(AlertLocation.top, AlertType.warning, fileViewerStrings[TranslationKey.DocumentLocked], hostElement);
  }
}
function setActionsAvailability(options, toolbarActions) {
  options.headerOptions = options.headerOptions || {};
  toolbarActions = toolbarActions || {};
  options.headerOptions.showApproveOption = !!toolbarActions.Approve;
  options.headerOptions.showSendOption = !!toolbarActions.Send;
  options.headerOptions.showRenameOption = !!toolbarActions.RenameDocument;
  options.headerOptions.showCopyOption = !!toolbarActions.CopyDocument;
  options.headerOptions.showMoveOption = !!toolbarActions.MoveDocument;
  // TODO: we want to use isCurrentDevelopment FRP for this button for now
  options.headerOptions.showOpenButton = options.headerOptions.showOpenButton && !!toolbarActions.Open;
  options.headerOptions.showUnlockOption = !!toolbarActions.Unlock;
  options.headerOptions.showDeleteOption = !!toolbarActions.DeleteDocument;
  options.headerOptions.showDownloadOption = !!toolbarActions.Download;
}
function configureThumbnailsOnlyView(webViewer, options) {
  webViewer.UI.openElements([WebViewerElement.leftPanel]);
  const leftPanelCloseBtnContainer = webViewer.UI.iframeWindow.document.querySelector('.close-container');
  const leftPanelHeader = webViewer.UI.iframeWindow.document.querySelector('.left-panel-header');
  leftPanelCloseBtnContainer === null || leftPanelCloseBtnContainer === void 0 ? void 0 : leftPanelCloseBtnContainer.remove();
  webViewer.UI.disableFeatures([
    PdfTronFeature$1.ThumbnailMerging,
    PdfTronFeature$1.MultipleViewerMerging,
  ]);
  const elementsToDisable = [WebViewerElement.thumbMultiRotate];
  if (!options.showMultiSelectForThumbnail) {
    elementsToDisable.push(WebViewerElement.thumbnailControl, WebViewerElement.moveToBottom, WebViewerElement.moveToTop, WebViewerElement.thumbnailsControlManipulatePopupTrigger, WebViewerElement.documentControl, WebViewerElement.thumbMultiDelete);
    webViewer.UI.disableFeatures([
      PdfTronFeature$1.ThumbnailReordering,
    ]);
    leftPanelHeader === null || leftPanelHeader === void 0 ? void 0 : leftPanelHeader.remove();
  }
  else {
    const leftPanelTabs = webViewer.UI.iframeWindow.document.querySelector('.Header');
    leftPanelTabs === null || leftPanelTabs === void 0 ? void 0 : leftPanelTabs.remove();
  }
  webViewer.UI.disableElements(elementsToDisable);
  removeDividerInPageManipulationOverlay(webViewer);
}
async function getDocumentBlob(webViewer, includeAnnotations, skipComments = false) {
  // A workaround, suggested by PDFTron support team. After downloading the document with a watermark,
  // it cannot be used anymore, so we create a copy of the document and download it instead.
  const watermark = await webViewer.Core.documentViewer.getWatermark();
  webViewer.Core.documentViewer.setWatermark({});
  const annotationManager = webViewer.Core.documentViewer.getAnnotationManager();
  const annotations = annotationManager
    .getAnnotationsList()
    .filter(annotation => !skipComments || !annotation.InReplyTo);
  const xfdfString = await annotationManager.exportAnnotations({
    annotList: includeAnnotations ? annotations : [],
    fields: true,
    widgets: true,
    links: true,
  });
  const doc = webViewer.Core.documentViewer.getDocument();
  const docType = doc.getType();
  const fileData = await doc.getFileData();
  webViewer.Core.documentViewer.setWatermark(watermark);
  const originalFileName = doc.getFilename();
  const documentCopyFileName = originalFileName.endsWith('.pdf') || docType === 'office' ? originalFileName : `${originalFileName}.pdf`;
  const documentCopyBlob = new Blob([new Uint8Array(fileData)]);
  const documentCopyUrl = URL.createObjectURL(documentCopyBlob);
  const documentCopy = await webViewer.Core.createDocument(documentCopyUrl, {
    filename: documentCopyFileName,
    loadAsPDF: true,
  });
  documentCopy.setWatermark(watermark);
  const options = { xfdfString };
  const data = await documentCopy.getFileData(options);
  const byteArray = new Uint8Array(data);
  const blob = new Blob([byteArray], { type: 'application/pdf' });
  documentCopy.unloadResources();
  return blob;
}
const customPrint = function (url) {
  const iframe = document.createElement('iframe');
  document.body.appendChild(iframe);
  iframe.style.display = 'none';
  iframe.src = url;
  iframe.onload = function () {
    iframe.focus();
    iframe.contentWindow.print();
  };
};
const isFirefox = function () {
  return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
};
async function printDocument(webViewer, options, printWarningMessageTemplate, hostElement, isPasswordProtected) {
  const documentName = webViewer.Core.documentViewer.getDocument().getFilename();
  webViewer.Core.annotationManager.enableReadOnlyMode();
  if (options.includeComments || isPasswordProtected) {
    const printProgressBanner = addClosableAlert(AlertLocation.top, AlertType.warning, getPrintWarningMessage(printWarningMessageTemplate, documentName, 0), hostElement);
    const pageCount = webViewer.Core.documentViewer.getPageCount();
    let completedPageCount = 0;
    webViewer.UI.printInBackground(Object.assign(Object.assign({}, options), { onProgress: (_pageNumber, page) => {
        // If page is img, then it is a document page. Comments pages should be omitted.
        if (printProgressBanner.parentNode && page.tagName.toLowerCase() === 'img') {
          completedPageCount++;
          const percentage = (completedPageCount / pageCount) * 100;
          printProgressBanner.innerText = getPrintWarningMessage(printWarningMessageTemplate, documentName, percentage);
          if (pageCount === completedPageCount) {
            webViewer.Core.documentViewer.setWatermark({});
            printProgressBanner.remove();
            webViewer.Core.annotationManager.disableReadOnlyMode();
            const tooltipElement = document.querySelector('.tooltip--bottom');
            if (tooltipElement) {
              tooltipElement.style.display = 'none';
            }
          }
        }
      } }));
  }
  else {
    // Passing skipComments=true, so that unnecessary comment icons wouldn't be present on a printed document.
    const blob = (await getDocumentBlob(webViewer, options.includeAnnotations, true));
    const url = URL.createObjectURL(blob);
    webViewer.Core.documentViewer.setWatermark({});
    if (isFirefox()) {
      customPrint(url);
    }
    else
      printJS(url);
    webViewer.Core.annotationManager.disableReadOnlyMode();
  }
}
function addClosableAlert(location, type, message, hostElement) {
  const container = hostElement.querySelector(location);
  const alertElement = document.createElement('bm-alert');
  alertElement.type = type;
  alertElement.closeable = true;
  alertElement.innerText = message;
  alertElement.addEventListener('close', () => {
    container === null || container === void 0 ? void 0 : container.removeChild(alertElement);
  });
  container === null || container === void 0 ? void 0 : container.append(alertElement);
  return alertElement;
}
function removeAlerts(hostElement, containerClass) {
  const container = hostElement.querySelector(containerClass);
  while (container === null || container === void 0 ? void 0 : container.hasChildNodes()) {
    container === null || container === void 0 ? void 0 : container.removeChild(container.firstChild);
  }
}
function getHigherZIndex() {
  const topLevels = [...document.querySelectorAll('body *')];
  let result = 0;
  for (const element of topLevels) {
    if (document.defaultView) {
      const elementIndex = Number(document.defaultView.getComputedStyle(element, undefined).getPropertyValue('z-index'));
      result = elementIndex > result ? elementIndex : result;
    }
  }
  return result;
}
function getPrintWarningMessage(messageTemplate, documentName, percentage) {
  return messageTemplate.replace('##DocumentName##', documentName).replace('##Percentage##', percentage.toFixed(1));
}
function getEnabledElements(options) {
  var _a, _b;
  const disabledElements = (_a = options.disabledElements) !== null && _a !== void 0 ? _a : [];
  disabledElements.push(WebViewerElement.menuButton);
  let enabledElements = (_b = options.enabledElements) !== null && _b !== void 0 ? _b : [];
  enabledElements = enableOrDisableAdditionalElements(enabledElements, [WebViewerElement.pageNavOverlay], options.showPageNavOverlayButtons);
  enabledElements = enableOrDisableAdditionalElements(enabledElements, viewControlsDropdown, options.showViewControlsDropdown);
  enabledElements = enableOrDisableAdditionalElements(enabledElements, cogMenu, options.showCogMenu);
  return allWebViewerElements.filter(element => !disabledElements.includes(element) &&
    (enabledElements.includes(element) ||
      (!options.disableDefaultElements && defaultWebViewerElements.includes(element))));
}
function enableOrDisableAdditionalElements(elements, additionalElements, enable) {
  if (enable) {
    return [...elements, ...additionalElements];
  }
  return elements.filter(element => !additionalElements.includes(element));
}
function removeDividerInPageManipulationOverlay(webViewer) {
  const pageManipulationOverlay = webViewer.UI.iframeWindow.document.querySelector('[data-element="pageManipulationOverlay"]');
  const overlayElements = pageManipulationOverlay === null || pageManipulationOverlay === void 0 ? void 0 : pageManipulationOverlay.children;
  const dividerClass = 'divider';
  for (let i = 0; i < (overlayElements === null || overlayElements === void 0 ? void 0 : overlayElements.length); i++) {
    let item = overlayElements[i];
    if (item.className === dividerClass && item.nextElementSibling.className === item.className) {
      item.remove();
    }
  }
}

/**
 * Provides ability to combine both internal and external logic of performing an action,
 * handling it's success and failure
 */
class Action {
  constructor(description) {
    this.description = description;
  }
  async performInternal(_arg) {
    return;
  }
  async onErrorInternal(_error) {
    return;
  }
  async onSuccessInternal(_actionResult) {
  }
  async perform(arg) {
    if (this.description.action && this.description.action.length > 1) {
      // in case external action requires success/failure handler and is responsible for calling them
      await this.performActionWithCallbacks(arg);
    }
    else {
      await this.performAction(arg);
    }
  }
  async performAction(arg) {
    let results;
    try {
      const action = this.description.action;
      const runInternal = this.performInternal(arg);
      const run = (action || (() => Promise.resolve(undefined)))(arg);
      results = await Promise.all([runInternal, run]);
    }
    catch (error) {
      await this.onErrorHandler(error);
      return;
    }
    const result = results[1];
    await this.onSuccessHandler(result);
  }
  async performActionWithCallbacks(arg) {
    const actionWithCallbacks = this.description.action;
    const runInternal = this.performInternal(arg);
    const run = actionWithCallbacks(arg, this.onSuccessHandler.bind(this), this.onErrorHandler.bind(this));
    await Promise.all([runInternal, run]);
  }
  async onSuccessHandler(result) {
    const onSuccessInternal = this.onSuccessInternal(result);
    const onSuccess = (this.description.onSuccess || (() => Promise.resolve(undefined)))(result);
    await Promise.all([onSuccessInternal, onSuccess]);
  }
  async onErrorHandler(error) {
    const onError = (this.description.onError || (() => Promise.resolve()))(error);
    const onErrorInternal = this.onErrorInternal(error);
    await Promise.all([onError, onErrorInternal]);
  }
}

class WebViewerDocumentAction extends Action {
  constructor(actionDescription, webViewer, context) {
    super(actionDescription);
    this.actionDescription = actionDescription;
    this.webViewer = webViewer;
    this.context = context;
  }
  notifyLockedStateChanged(locked) {
    var _a;
    (_a = this.getViewerFromContext()) === null || _a === void 0 ? void 0 : _a.notifyLockedStateChanged(locked);
  }
  getViewerFromContext() {
    var _a;
    const coreViewer = (_a = this.context) === null || _a === void 0 ? void 0 : _a.data;
    return coreViewer;
  }
}
class ActionContext {
  constructor(data) {
    this.data = data;
  }
}

class ApproveAction extends WebViewerDocumentAction {
  constructor(actionSet, webViewer, context) {
    super(actionSet.Approve || {}, webViewer, context);
  }
  async onSuccessInternal(result) {
    if (!!result) {
      const viewer = this.getViewerFromContext();
      if (viewer) {
        const currentDocumentId = viewer.currentDocumentId;
        const isCurrentDocumentPresent = !!result.documents.find(x => x.id === currentDocumentId);
        if (isCurrentDocumentPresent) {
          this.notifyLockedStateChanged(true);
        }
      }
    }
  }
}

class SendAction extends WebViewerDocumentAction {
  constructor(actionSet, webViewer, context) {
    super(actionSet.Send || {}, webViewer, context);
  }
}

class OpenAction extends WebViewerDocumentAction {
  constructor(actionSet, webViewer, context) {
    super(actionSet.Open || {}, webViewer, context);
  }
  async onSuccessInternal(result) {
    var _a;
    if (result.lockResult !== false && ((_a = this.getViewerFromContext()) === null || _a === void 0 ? void 0 : _a.currentDocumentId) === result.documentId) {
      this.notifyLockedStateChanged(true);
    }
  }
}

class CopyAction extends WebViewerDocumentAction {
  constructor(actionSet, webViewer, context) {
    super(actionSet.CopyDocument || {}, webViewer, context);
  }
}

class DeleteAction extends WebViewerDocumentAction {
  constructor(actionSet, webViewer, context) {
    super(actionSet.DeleteDocument || {}, webViewer, context);
  }
  async onSuccessInternal(result) {
    var _a;
    if (result !== false) {
      (_a = this.getViewerFromContext()) === null || _a === void 0 ? void 0 : _a.closeClicked.emit();
    }
  }
}

class DownloadAction extends WebViewerDocumentAction {
  constructor(actionSet, webViewer, context) {
    super(actionSet.Download || {}, webViewer, context);
  }
  async onSuccessInternal() {
    var _a;
    if (this.context.data) {
      (_a = this.getViewerFromContext()) === null || _a === void 0 ? void 0 : _a.downloadClicked.emit({ customDownload: true });
    }
  }
}

class MoveAction extends WebViewerDocumentAction {
  constructor(actionSet, webViewer, context) {
    super(actionSet.MoveDocument || {}, webViewer, context);
  }
  async onSuccessInternal(result) {
    var _a;
    if (result !== false) {
      (_a = this.getViewerFromContext()) === null || _a === void 0 ? void 0 : _a.closeClicked.emit();
    }
  }
}

class RenameAction extends WebViewerDocumentAction {
  constructor(actionSet, webViewer, context) {
    super(actionSet.RenameDocument || {}, webViewer, context);
  }
  async onSuccessInternal(result) {
    var _a;
    if (result !== false) {
      const newName = result[0].name;
      (_a = this.getViewerFromContext()) === null || _a === void 0 ? void 0 : _a.renameDocument(newName);
    }
  }
}

class UnlockAction extends WebViewerDocumentAction {
  constructor(actionSet, webViewer, context) {
    super(actionSet.Unlock || {}, webViewer, context);
  }
  async onSuccessInternal(result) {
    var _a;
    if (result.successful) {
      this.notifyLockedStateChanged(false);
    }
    else if (result.detail === 'esign') {
      (_a = this.getViewerFromContext()) === null || _a === void 0 ? void 0 : _a.notifyUnlockFailed();
    }
  }
}

class InsertScanAction extends WebViewerDocumentAction {
  constructor(actionSet, webViewer, context) {
    super(actionSet.InsertScan || {}, webViewer, context);
  }
}

const Approve = ApproveAction;
const Send = SendAction;
const Open = OpenAction;
const Copy = CopyAction;
const Delete = DeleteAction;
const Download = DownloadAction;
const Move = MoveAction;
const Rename = RenameAction;
const Unlock = UnlockAction;
const InsertScan = InsertScanAction;

const bmCoreFileViewerCss = ":host{height:100%;display:flex;flex-direction:column}bmcfv-header{flex-grow:0}#webviewer-container,#webviewer-container div{height:100%}figure{flex-grow:1;margin:0}.hide{display:none}.bottom-alerts-container{margin:auto;top:100%;width:50%;left:25%;transform:translateY(-100%);position:absolute}.top-alerts-container{margin:auto;width:50%;left:25%;top:96px;position:absolute}";

// spell-checker:ignore Agmt
const licenseKey = 'Thomson Reuters Holdings Inc. (thomsonreuters.com):OEM:Onvio Firm Management, Onvio Documents, Onvio Client Center, GoFileRoom, AdvanceFlow, PracticalLaw::B+:AMS(20240426):F6A518CD0457480A0360B13AC982537860615F3EB766E50395B51BD45CD5009E1A8A31F5C7';
const BmCoreFileViewer$1 = class extends HTMLElement {
  async optionsChanged() {
    var _a;
    if (this.webViewerInstance) {
      setActionsAvailability(this.options, this.toolbarActions);
      configureWebViewer(this.webViewerInstance, this.options, (_a = this.element) === null || _a === void 0 ? void 0 : _a.shadowRoot, this.fileViewerStrings, this.isDocumentLoaded);
      if (this.webViewerInstance.UI.hotkeys) {
        configureHotKeys(this.webViewerInstance, this.options, () => {
          this.showPrintModal = this.isSupported && this.canPrint();
        });
      }
    }
  }
  async documentChanged() {
    // If webViewer isn't instantiated yet we don't need to do anything.
    // The code the instantiates webViewer will load the document after it's done.
    this._retrievedDocumentName = null;
    this.isDocumentValid = true;
    this.isPasswordProtected = false;
    if (this.webViewerInstance && this.document) {
      this.documentLoadedPromise = deferred();
      this.loadDocument(this.webViewerInstance);
    }
  }
  webViewerPathChanged() {
    // Instantiate WebViewer if necessary
    if (!this.webViewerStarted) {
      void this.instantiateWebViewer();
    }
  }
  documentNameChanged() {
    var _a;
    if (!this.webViewerStarted && this.isSupported()) {
      void this.instantiateWebViewer();
    }
    else if (!this.isSupported() && ((_a = this.webViewerInstance) === null || _a === void 0 ? void 0 : _a.Core.documentViewer)) {
      void this.webViewerInstance.Core.documentViewer.closeDocument();
    }
  }
  customSelectThumbnailPages() {
    if (!this.selectThumbnailPages)
      return;
    const currentPage = this.webViewerInstance.Core.documentViewer.getCurrentPage();
    this.webViewerInstance.UI.ThumbnailsPanel.unselectPages([currentPage]);
    this.webViewerInstance.Core.documentViewer.setCurrentPage(0, false);
    this.webViewerInstance.Core.documentViewer.setCurrentPage(this.selectThumbnailPages, false);
  }
  /**
   * Stencil lifecycle hook, only runs once after initialization is complete
   */
  componentDidLoad() {
    if (!this.webViewerStarted) {
      void this.instantiateWebViewer();
    }
  }
  /**
   * True if no document is loaded or the loaded document is supported.
   * Both document name passed as input and retrieved after the load are checked,
   * because the one, passed as the input might have different extension, just for the display.
   */
  isSupported() {
    return (!this._documentName() && !this.document ||
      !this._documentName() ||
      (this.documentName && this.isWebViewerClientSupported(this._documentName())) ||
      (this._retrievedDocumentName && this.isWebViewerClientSupported(this._retrievedDocumentName)));
  }
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.webViewerInstantiated = createEvent(this, "webViewerInstantiated", 7);
    this.documentLoaded = createEvent(this, "documentLoaded", 7);
    this.documentUnloaded = createEvent(this, "documentUnloaded", 7);
    this.closeClicked = createEvent(this, "closeClicked", 7);
    this.downloadClicked = createEvent(this, "downloadClicked", 7);
    this.documentLoadFailed = createEvent(this, "documentLoadFailed", 7);
    this.printClicked = createEvent(this, "printClicked", 7);
    this.lockedStateChanged = createEvent(this, "lockedStateChanged", 7);
    this.documentRenamed = createEvent(this, "documentRenamed", 7);
    this.isWebViewerClientSupported = isWebViewerClientSupported;
    this.isPasswordProtected = false;
    this.areAllElementsDisabled = false;
    /**
     * Indicates if WebViewer initialization has started
     * Does *not* reflect whether or not instantiation is complete
     */
    this.webViewerStarted = false;
    this.options = {};
    this.document = undefined;
    this.selectThumbnailPages = undefined;
    this.documentOptions = {};
    this.webViewerPath = undefined;
    this.documentName = '';
    this.qeIdPrefix = '';
    this.editAnnotations = false;
    this.customStylesPath = undefined;
    this.toolbarActions = undefined;
    this.watermarkSettings = undefined;
    this.isCombinePDFBrokenPdfMessage = undefined;
    this._retrievedDocumentName = undefined;
    this.isDocumentLoaded = false;
    this.fileViewerStrings = undefined;
    this.showPrintModal = false;
    this.showWatermarkModal = false;
    this.showPrintModalBusyLoader = false;
    this.isDocumentValid = true;
    this.exposeVersionNumber();
    configureTranslations();
    this.fileViewerStrings = getStrings();
    this.languageChangeUnsubscribe = onLanguageChange(() => {
      this.fileViewerStrings = getStrings();
    });
  }
  disconnectedCallback() {
    this.languageChangeUnsubscribe();
  }
  render() {
    var _a;
    return [
      h("div", { class: "top-alerts-container" }),
      (((_a = this.options) === null || _a === void 0 ? void 0 : _a.showHeader) ? this.renderHeader() : null),
      (this.isDocumentLoaded ? this.renderPrintModal() : null),
      (this.isDocumentLoaded ? this.renderWatermarkModal() : null),
      h("figure", { id: "webviewer-container", class: this.isSupported ? '' : 'hide' }),
      (this.isSupported() && this.isDocumentValid ? null : this.fileNotLoadedModal()),
      h("div", { class: "bottom-alerts-container" }),
    ];
  }
  renderHeader() {
    return h("bmcfv-header", { "qe-id-prefix": `${this.qeIdPrefix}core-file-viewer-`, options: this.options, "document-name": this._documentName(), "show-print-button": this.canPrint(), fileViewerStrings: this.fileViewerStrings, onCloseClicked: () => this.closeClicked.emit(), onPrintClicked: () => this.onPrintClickedOnHeader(), onOpenClicked: () => void this.performAction(Open), onDownloadClicked: (event) => void this.performAction(Download, event), onCopyClicked: () => void this.performAction(Copy), onMoveClicked: () => void this.performAction(Move), onDeleteClicked: () => void this.performAction(Delete), onApproveClicked: () => void this.performAction(Approve), onSendClicked: () => void this.performAction(Send), onUnlockClicked: () => void this.performAction(Unlock), onRenameClicked: () => void this.performAction(Rename), onInsertScanClicked: () => void this.performAction(InsertScan) });
  }
  fileNotLoadedModal() {
    var _a;
    if (document.fullscreenElement) {
      void document.exitFullscreen();
    }
    removeAlerts((_a = this.element) === null || _a === void 0 ? void 0 : _a.shadowRoot, AlertLocation.top);
    return h("bmcfv-file-not-loaded-modal", { "qe-id-prefix": `${this.qeIdPrefix}core-file-viewer-`, isCombinePDFBrokenPdfMessage: this.isCombinePDFBrokenPdfMessage, fileViewerStrings: this.fileViewerStrings, onDownloadClicked: (event) => {
        // otherwise this event will bubble and client code will end up receiving two downloadClicked events
        event.cancelBubble = true;
        this.downloadClicked.emit();
      }, "is-file-supported": this.isSupported() });
  }
  renderPrintModal() {
    return this.showPrintModal ? (h("bmcfv-modal-template", { "modal-title": this.fileViewerStrings[TranslationKey.PrintOptions], "content-height": 200, "modal-id": "print", onCloseButtonClick: () => this.onPrintModalCloseClick() }, h("bmcfv-print-options", { class: "modal-content-print", fileViewerStrings: this.fileViewerStrings, showBusyLoader: this.showPrintModalBusyLoader, annotationsAllowed: this.editAnnotations, onWatermarkModalRequested: () => {
        this.showWatermarkModal = true;
      }, onPrint: async (ev) => this.onPrintClickedOnModal(ev) }))) : null;
  }
  renderWatermarkModal() {
    return this.showWatermarkModal ? (h("bmcfv-modal-template", { "modal-title": this.fileViewerStrings[TranslationKey.AddWatermark], "content-height": 500, "modal-id": "watermark", "close-button-qe-id": 'watermark-modal-close-button' }, h("bmcfv-watermark-options", { class: "modal-content-watermark", fileViewerStrings: this.fileViewerStrings, watermarkSettings: this.watermarkSettings, onWatermarkChanged: (ev) => void this.watermarkChanged(ev), onClosed: () => this.watermarkModalClosedHandler() }))) : null;
  }
  onPrintModalCloseClick() {
    this.showPrintModal = false;
    void this.webViewerInstance.Core.documentViewer.setWatermark({});
    this.watermarkSettings = null;
    this.focusViewer();
  }
  async watermarkChanged(event) {
    await this.documentLoadedPromise;
    this.watermarkSettings = Object.assign({}, event.detail.options);
    const docViewer = this.webViewerInstance.Core.documentViewer;
    void docViewer.setWatermark(event.detail.options);
    const desiredWidth = 283;
    const maxHeight = 418;
    const pageNumber = 1;
    const rotation = this.webViewerInstance.Core.documentViewer.getCompleteRotation(pageNumber);
    const width = docViewer.getPageWidth(pageNumber);
    const height = docViewer.getPageHeight(pageNumber);
    // swap page width and height when it is 90 or 270 degrees rotated
    const pageWidth = rotation % 2 === 1 ? height : width;
    const pageHeight = rotation % 2 === 1 ? width : height;
    const zoom = (desiredWidth * pageHeight) / pageWidth > maxHeight ? maxHeight / pageHeight : desiredWidth / pageWidth;
    docViewer.getDocument().loadCanvas({
      pageNumber: pageNumber,
      zoom: zoom,
      // eslint-disable-next-line
      drawComplete: (canvas) => {
        event.detail.canvasContainer.innerHTML = '';
        event.detail.canvasContainer.appendChild(canvas);
      },
    });
  }
  watermarkModalClosedHandler() {
    this.showWatermarkModal = false;
    this.focusPrintModal();
  }
  async onPrintClickedOnModal(event) {
    var _a;
    try {
      this.showPrintModalBusyLoader = true;
      await printDocument(this.webViewerInstance, event.detail, this.fileViewerStrings[TranslationKey.PrintWarningMessage], (_a = this.element) === null || _a === void 0 ? void 0 : _a.shadowRoot, this.isPasswordProtected);
      this.showPrintModalBusyLoader = false;
      this.showPrintModal = false;
      this.watermarkSettings = null;
      this.focusViewer();
    }
    catch (error) {
      console.error(error);
    }
  }
  notifyLockedStateChanged(locked) {
    this.lockedStateChanged.emit(locked);
  }
  notifyUnlockFailed() {
    var _a;
    addClosableAlert(AlertLocation.bottom, AlertType.danger, this.fileViewerStrings[TranslationKey.ESignedDocumentWontUnlock], (_a = this.element) === null || _a === void 0 ? void 0 : _a.shadowRoot);
  }
  renameDocument(newDocumentName) {
    this.documentName = newDocumentName;
    this.documentRenamed.emit(newDocumentName);
  }
  get currentDocumentId() {
    return this.documentOptions.documentId;
  }
  _documentName() {
    var _a;
    return (_a = (this.documentName || this._retrievedDocumentName)) !== null && _a !== void 0 ? _a : '';
  }
  async instantiateWebViewer() {
    var _a;
    this.documentLoadedPromise = deferred();
    const container = this.getWebViewerContainer();
    const options = this.getWebViewerOptions();
    if (!container || !options.path) {
      return;
    }
    this.webViewerStarted = true;
    this.destroyWebViewerInstance();
    this.webViewerInstance = await WebViewer(options, container);
    await this.webViewerInstance.Core.PDFNet.initialize(licenseKey);
    this.webViewerInstantiated.emit(this.webViewerInstance);
    const { Annotations } = this.webViewerInstance.Core;
    Annotations.Forms.EmbeddedJS.update(scope => {
      scope.global = {};
    });
    this.configureDocViewerEvents();
    configureWebViewer(this.webViewerInstance, this.options, (_a = this.element) === null || _a === void 0 ? void 0 : _a.shadowRoot, this.fileViewerStrings, this.isDocumentLoaded);
    if (this.document) {
      this.loadDocument(this.webViewerInstance);
    }
  }
  async performAction(actionCtor, event) {
    if (event) {
      event.cancelBubble = true;
    }
    const action = new actionCtor(this.toolbarActions, this.webViewerInstance, new ActionContext(this));
    const documentId = this.documentOptions.documentId;
    await action.perform(documentId);
  }
  configureDocViewerEvents() {
    const docViewer = this.webViewerInstance.Core.documentViewer;
    docViewer.addEventListener('documentLoaded', () => this.onDocumentLoaded(docViewer.getDocument()));
    docViewer.addEventListener('documentUnloaded', () => this.onDocumentUnloaded());
    this.webViewerInstance.UI.addEventListener(this.webViewerInstance.UI.Events.LOAD_ERROR, (error) => {
      this.handleDocumentLoadError(error);
    });
    this.webViewerInstance.UI.iframeWindow.addEventListener('visibilityChanged', (event) => {
      var _a;
      const detail = event.detail;
      if (detail.element === WebViewerElement.passwordModal && detail.isVisible) {
        this.isPasswordProtected = true;
        removeAlerts((_a = this.element) === null || _a === void 0 ? void 0 : _a.shadowRoot, AlertLocation.top);
      }
    });
  }
  destroyWebViewerInstance() {
    if (this.webViewerInstance) {
      void this.webViewerInstance.UI.dispose();
    }
    const container = this.getWebViewerContainer();
    if (container) {
      // This is what actually unloads WebViewer from the DOM
      container.innerHTML = '';
    }
    this.webViewerInstance = undefined;
    this.isDocumentLoaded = false;
  }
  loadDocument(instance) {
    const document = this.document.constructor.name === 'Blob' ? URL.createObjectURL(this.document) : this.document;
    instance.UI.loadDocument(document, this.documentOptions);
  }
  onDocumentLoaded(document) {
    var _a, _b, _c, _d;
    if (this.documentLoadedPromise !== undefined) {
      this.documentLoadedPromise.resolve();
    }
    this.isDocumentLoaded = true;
    this._retrievedDocumentName = document.getFilename();
    // Fix for edge case when document lose its toolabar after switch from broken document #2777441
    if (this.areAllElementsDisabled) {
      this.areAllElementsDisabled = false;
      configureWebViewer(this.webViewerInstance, this.options, (_a = this.element) === null || _a === void 0 ? void 0 : _a.shadowRoot, this.fileViewerStrings, this.isDocumentLoaded);
    }
    this.documentLoaded.emit(document);
    this.webViewerInstance.UI.setZoomLevel((_b = this.options.zoomLevel) !== null && _b !== void 0 ? _b : webViewerDefaultZoom);
    if (this.options.showPageNavOverlayButtons) {
      this.overridePageNavOverlayTranslations(this.webViewerInstance);
    }
    removeAlerts((_c = this.element) === null || _c === void 0 ? void 0 : _c.shadowRoot, AlertLocation.top);
    if (this.options.editable && this.options.readonly && this.isDocumentValid) {
      addClosableAlert(AlertLocation.top, AlertType.warning, this.fileViewerStrings[TranslationKey.DocumentLocked], (_d = this.element) === null || _d === void 0 ? void 0 : _d.shadowRoot);
    }
  }
  onDocumentUnloaded() {
    var _a;
    this.isDocumentLoaded = false;
    this.documentUnloaded.emit();
    removeAlerts((_a = this.element) === null || _a === void 0 ? void 0 : _a.shadowRoot, AlertLocation.top);
  }
  onPrintClickedOnHeader() {
    var _a;
    const printClickEvent = this.printClicked.emit();
    if (!printClickEvent.defaultPrevented) {
      void this.webViewerInstance.Core.documentViewer.setWatermark((_a = this.watermarkSettings) !== null && _a !== void 0 ? _a : {});
      this.showPrintModal = true;
    }
  }
  canPrint() {
    var _a, _b;
    return (((_a = this.options) === null || _a === void 0 ? void 0 : _a.canPrint) || ((_b = this.options) === null || _b === void 0 ? void 0 : _b.canPrint) === undefined) && this.isDocumentLoaded && this.isSupported();
  }
  getWebViewerOptions() {
    var _a, _b, _c;
    const path = (_a = this.webViewerPath) !== null && _a !== void 0 ? _a : (_b = this.options) === null || _b === void 0 ? void 0 : _b.path;
    const options = (_c = this.options) !== null && _c !== void 0 ? _c : {};
    const disabledElements = this.getDisabledElements();
    return Object.assign(Object.assign({ licenseKey, css: this.customStylesPath, path }, options), { disabledElements, fullAPI: true, backendType: 'ems' });
  }
  getDisabledElements() {
    const enabledElements = getEnabledElements(this.options);
    return allWebViewerElements.filter(element => !enabledElements.includes(element));
  }
  getWebViewerContainer() {
    var _a;
    return (_a = this.element) === null || _a === void 0 ? void 0 : _a.shadowRoot.querySelector('#webviewer-container');
  }
  overridePageNavOverlayTranslations(webViewer) {
    const pageNavOverlay = webViewer.UI.iframeWindow.document.querySelector(`[data-element="${WebViewerElement.pageNavOverlay}"]`);
    if (pageNavOverlay) {
      const pageNavOverlayButtons = pageNavOverlay.querySelectorAll('button');
      const previousButton = pageNavOverlayButtons[0];
      const nextButton = pageNavOverlayButtons[1];
      if (previousButton && nextButton) {
        const previousButtonTitle = previousButton.querySelector('button svg title');
        const nextButtonTitle = nextButton.querySelector('button svg title');
        previousButtonTitle.innerHTML = this.fileViewerStrings[TranslationKey.PreviousButtonTitle];
        nextButtonTitle.innerHTML = this.fileViewerStrings[TranslationKey.NextButtonTitle];
      }
    }
  }
  exposeVersionNumber() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.bmdms = window.bmdms || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.bmdms.coreFileViewer = { version: '58.4.0' };
  }
  handleDocumentLoadError(error) {
    var _a, _b;
    this.isDocumentValid = false;
    const container = (_a = this.element) === null || _a === void 0 ? void 0 : _a.shadowRoot.querySelector(AlertLocation.top);
    if (container.hasChildNodes()) {
      removeAlerts((_b = this.element) === null || _b === void 0 ? void 0 : _b.shadowRoot, AlertLocation.top);
      this.webViewerInstance.UI.disableElements(allWebViewerElements);
    }
    this.areAllElementsDisabled = true;
    this.documentLoadFailed.emit(error.detail);
  }
  focusViewer() {
    this.element.focus();
  }
  focusPrintModal() {
    const modalDialog = document.body.querySelector('.modal-dialog-print');
    void modalDialog.focus();
  }
  get element() { return this; }
  static get watchers() { return {
    "options": ["optionsChanged"],
    "document": ["documentChanged"],
    "webViewerPath": ["webViewerPathChanged"],
    "documentName": ["documentNameChanged"],
    "selectThumbnailPages": ["customSelectThumbnailPages"]
  }; }
  static get style() { return bmCoreFileViewerCss; }
};

const bmcfvBusyLoaderCss = ".bmcfv-busy-loader-svg>path{stroke-width:15;stroke:#afafaf;animation-duration:1.2s;-webkit-animation-duration:1.2s;animation-fill-mode:forwards;-webkit-animation-fill-mode:forwards;animation-iteration-count:infinite;-webkit-animation-iteration-count:infinite;animation-name:busy-loader-rotation;-webkit-animation-name:busy-loader-rotation;animation-timing-function:linear;-webkit-animation-timing-function:linear}.bmcfv-busy-loader-svg>path:nth-child(1){animation-delay:1.2s;-webkit-animation-delay:1.2s}.bmcfv-busy-loader-svg>path:nth-child(2){animation-delay:calc(1.2s / 7 * 6);-webkit-animation-delay:calc(1.2s / 7 * 6)}.bmcfv-busy-loader-svg>path:nth-child(3){animation-delay:calc(1.2s / 7 * 5);-webkit-animation-delay:calc(1.2s / 7 * 5)}.bmcfv-busy-loader-svg>path:nth-child(4){animation-delay:calc(1.2s / 7 * 4);-webkit-animation-delay:calc(1.2s / 7 * 4)}.bmcfv-busy-loader-svg>path:nth-child(5){animation-delay:calc(1.2s / 7 * 3);-webkit-animation-delay:calc(1.2s / 7 * 3)}.bmcfv-busy-loader-svg>path:nth-child(6){animation-delay:calc(1.2s / 7 * 2);-webkit-animation-delay:calc(1.2s / 7 * 2)}.bmcfv-busy-loader-svg>path:nth-child(7){animation-delay:calc(1.2s / 7);-webkit-animation-delay:calc(1.2s / 7)}.bmcfv-busy-loader-svg>path:nth-child(8){animation-delay:0s;-webkit-animation-delay:0s}@keyframes busy-loader-rotation{0%{stroke:#afafaf}30%,60%{stroke:#fa6400}90%,100%{stroke:#afafaf}}@-webkit-keyframes busy-loader-rotation{0%{stroke:#afafaf}30%,60%{stroke:#fa6400}90%,100%{stroke:#afafaf}}";

const BmcfvBusyLoader$1 = class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
  }
  render() {
    return (h("svg", { class: "bmcfv-busy-loader-svg", viewBox: "0 0 75 75" }, h("path", { d: "M39.331 67.444a30 30 0 0018.048-7.475" }), h("path", { d: "M59.969 57.379a30 30 0 007.475-18.048" }), h("path", { d: "M67.444 35.669a30 30 0 00-7.475-18.048" }), h("path", { d: "M57.379 15.031A30 30 0 0039.33 7.556" }), h("path", { d: "M35.669 7.556a30 30 0 00-18.048 7.475" }), h("path", { d: "M15.031 17.621A30 30 0 007.556 35.67" }), h("path", { d: "M7.556 39.331a30 30 0 007.475 18.048" }), h("path", { d: "M17.621 59.969a30 30 0 0018.048 7.475" })));
  }
  static get style() { return bmcfvBusyLoaderCss; }
};

const palette = [
  '#F1A099',
  '#FFC67B',
  '#FFE6A2',
  '#80E5B1',
  '#92E8E8',
  '#A6A1E6',
  '#E2A1E6',
  '#E44234',
  '#FF8D00',
  '#FFCD45',
  '#00CC63',
  '#25D2D1',
  '#4E7DE9',
  '#C544CE',
  '#88271F',
  '#B54800',
  '#F69A00',
  '#007A3B',
  '#167E7D',
  '#2E4B8B',
  '#76287B',
  '#FFFFFF',
  '#CDCDCD',
  '#9C9C9C',
  '#696969',
  '#272727',
  '#000000',
];
const defaultColor = palette[7];

const bmcfvColorPaletteCss = ".color-palette{display:grid;grid-template-columns:repeat(7, 1fr);padding:10px}.cell-container{cursor:pointer;width:28px;height:28px;padding:0;display:flex;align-items:center;justify-content:center;border:none;background-color:transparent}.cell-outer{width:26px;height:26px;display:flex;align-items:center;justify-content:center}.active{border:1px solid #485056;border-radius:100px}.cell{width:18px;height:18px;border-radius:100px}.border{border:1px solid #cfd4da}";

const BmcfvColorPalette$1 = class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.colorChanged = createEvent(this, "colorChanged", 7);
    this.currentColor = undefined;
  }
  render() {
    const buttons = palette.map((color, i) => this.color(color, i));
    return h("div", { class: "color-palette" }, buttons);
  }
  color(color, key) {
    var _a;
    const outerCellClassMap = color.toLowerCase() === ((_a = this.currentColor) === null || _a === void 0 ? void 0 : _a.toLowerCase()) ? {
      'cell-outer': true,
      active: true
    } : { 'cell-outer': true };
    const cellClassMap = color.toLocaleLowerCase() === '#ffffff' ? {
      'cell': true,
      border: true
    } : { 'cell': true };
    return h("button", { id: String(key), class: "cell-container", onClick: () => {
        this.colorChanged.emit(color);
      }, "data-qe-id": `color ${key}` }, h("div", { class: outerCellClassMap }, h("div", { class: cellClassMap, style: { 'background-color': color } })));
  }
  static get style() { return bmcfvColorPaletteCss; }
};

const bmcfvFileNotLoadedModalCss = ":host{display:block;height:100%;width:100%;background-color:#f4f5f7;flex-direction:column;flex:1;display:flex;align-items:center}.preview-modal,.preview-modal-combine{box-sizing:border-box;background-color:#ffffff;border:1px solid #b2b2b8;display:flex;flex-direction:column;justify-content:space-around;position:fixed;top:calc(50% - 118px);height:140px;width:500px;padding:25px;color:rgb(255, 255, 255);margin-top:30px;box-shadow:1px 2px 2px rgba(0,0,0,0.2)}.modal-header,.modal-header-combine{border-bottom:1px solid #e5e5e5;padding:0 0 10px;font-weight:500;font-size:20px;color:rgb(33, 33, 33);margin-bottom:10px}.btn-primary{border:none}.modal-container{font-family:KnowledgeLight, arial, helvetica, sans-serif;width:100%}.print-header{font-size:13px;display:block;font-family:Lato, sans-serif;padding:5px}.btn{padding:0 12px;font-size:14px;height:30px;line-height:30px;letter-spacing:0.28px;max-width:100%;min-width:85px;white-space:nowrap;overflow:hidden;border-radius:5px;align-items:center;border-style:solid;border-width:1px;display:inline-flex;font-family:BentoRegular, arial, helvetica, sans-serif;font-weight:400;justify-content:center;transition:color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\n\t\tbox-shadow 0.15s ease-in-out;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;vertical-align:middle}.btn-primary{color:#fff;background-color:#666;border-color:#666}.btn-primary.focus,.btn-primary:focus{text-decoration:none;color:#fff;border-color:#fff;outline:none;box-shadow:0 0 0 1px #383838 !important;z-index:1}.btn-primary:hover{text-decoration:none;color:#fff;background-color:#2c2c2c;border-color:#2c2c2c}.btn.focus,.btn:focus{outline:0;box-shadow:0 0 0 0.2rem rgb(0 123 255 / 25%)}.btn:focus,.btn:hover{ext-decoration:none}.btn:not(:disabled):not(.disabled){cursor:pointer}@media only screen and (min-width: 320px) and (max-width: 580px){.preview-modal-combine{width:90vw;height:65vh;left:5vw;padding-bottom:0;top:5vh}.modal-header-combine{font-size:16px}.modal-container button[id='download-button']{position:relative;bottom:3vh}}";

const BmcfvFileNotLoadedModal$1 = class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.downloadClicked = createEvent(this, "downloadClicked", 7);
    this.qeIdPrefix = '';
    this.isFileSupported = undefined;
    this.fileViewerStrings = {};
    this.isCombinePDFBrokenPdfMessage = undefined;
  }
  render() {
    const qeid = 'dms-fe-core-file-viewer-combine-preview-panel-download-pdf-button';
    this.qeIdPrefix = this.isCombinePDFBrokenPdfMessage ? qeid : this.qeIdPrefix + 'download-button';
    return (h("div", { class: this.isCombinePDFBrokenPdfMessage ? "preview-modal-combine" : "preview-modal" }, h("div", { class: "modal-container" }, h("div", { class: this.isCombinePDFBrokenPdfMessage ? "modal-header-combine" : "modal-header" }, this.isFileSupported
      ? this.fileViewerStrings[TranslationKey.DocumentIsInvalid]
      : this.fileViewerStrings[TranslationKey.PreviewNotAvailable]), h("button", { "qe-id": this.qeIdPrefix, id: 'download-button', type: "button", class: "btn btn-primary", onClick: () => this.downloadClicked.emit() }, this.fileViewerStrings[TranslationKey.Download]))));
  }
  static get style() { return bmcfvFileNotLoadedModalCss; }
};

// These could be constants but node re-use can cause caching problems
// https://stenciljs.com/docs/templating-jsx#avoid-shared-jsx-nodes
const closeIcon = () => (h("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" },
  h("g", { transform: "scale(2 2)", "stroke-width": "1" },
    h("path", { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", "data-cap": "butt", d: "M13.5 2.5l-11 11" }),
    h("path", { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", "data-cap": "butt", d: "M2.5 2.5l11 11" }))));
const printIcon = () => (h("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" },
  h("g", { transform: "scale(2 2)" },
    h("path", { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", d: "M3.5 3.5v-3h9v3" }),
    h("path", { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", d: "M3.5 12.5h-3v-7h15v7h-3" }),
    h("path", { fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", d: "M3.5 9.5h9v6h-9z" }))));
const openIcon = () => (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" },
  h("g", { class: "nc-icon-wrapper", fill: "none", stroke: "default" },
    h("path", { class: "st0", d: "M7.2 7.5h8.3M11.5 3.5l4 4-4 4M.5 13.6V.5h9.9M10.4 14.5H5", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10" }),
    h("path", { class: "st0", d: "M1.2.8l3.6 1.9v12.8L.5 13.8", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10" }))));
const caretDownFilledIcon = () => (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12" },
  h("path", { d: "M2.25 3.75L6 8.25l3.75-4.5z", fill: "default" })));
const copyIcon = () => (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" },
  h("g", { stroke: "default", fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10" },
    h("path", { d: "M2.5 3.5h10v12h-10z" }),
    h("path", { "data-color": "color-2", d: "M4.5.5h11v13" }),
    h("path", { d: "M5.5 6.5h4M5.5 9.5h4M5.5 12.5h4" }))));
const downloadIcon = () => (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" },
  h("g", { stroke: "default", fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round" },
    h("path", { "stroke-miterlimit": "10", "data-color": "color-2", d: "M3.5 6.5l4.5 5 4.5-5h-3v-6h-3v6z" }),
    h("path", { d: "M15.5 10.5v4a1 1 0 01-1 1h-13a1 1 0 01-1-1v-4" }))));
const envelopeIcon = () => (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" },
  h("g", { stroke: "default", fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10" },
    h("path", { d: "M14.5 14.5h-13a1 1 0 01-1-1v-11a1 1 0 011-1h13a1 1 0 011 1v11a1 1 0 01-1 1z" }),
    h("path", { "data-color": "color-2", d: "M2.5 4.5L8 9l5.5-4.5" }))));
const moveIcon = () => (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" },
  h("g", { stroke: "default", fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round" },
    h("path", { d: "M8.5 15.5v-14M1.5 8.5h14M6.5 3.5l2-2 2 2M6.5 13.5l2 2 2-2M13.5 6.5l2 2-2 2M3.5 6.5l-2 2 2 2" }))));
const removeIcon = () => (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" },
  h("g", { fill: "none", stroke: "default", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10" },
    h("path", { d: "M1.5 6v7.389c0 1.161.975 2.111 2.167 2.111h8.666c1.192 0 2.167-.95 2.167-2.111V6M.5 3.5h15M5.5 3.5v-3h5v3M11.5 7.5v5M4.5 7.5v5M8 7.5v5" }))));
const renameIcon = () => (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" },
  h("g", { fill: "none", stroke: "default" },
    h("path", { d: "M8.1 1.1c1.7 0 3 1.3 3 3v8.1c0 1.7-1.3 3-3 3M11.1 12.2c0 1.7 1.3 3 3 3M14.1 1.1c-1.7 0-3 1.3-3 3", "stroke-linecap": "round", "stroke-linejoin": "round" }),
    h("path", { d: "M9.2 5.7H1.4v6h7.9M12.3 5.7h2.9v6h-3", "stroke-miterlimit": "10" }))));
const insertScanIcon = () => (h("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "3 5 18 15", height: "16", width: "16", class: "insert-scan" },
  h("path", { d: "M 17.6 12 L 3.5 6.9 L 4.2 5 l 15.6 5.7 q 0.5 0.2 0.85 0.7 q 0.35 0.5 0.35 1.1 V 18 q 0 0.825 -0.587 1.413 Q 19.825 20 19 20 H 5 q -0.825 0 -1.413 -0.587 Q 3 18.825 3 18 v -4 q 0 -0.825 0.587 -1.413 Q 4.175 12 5 12 Z M 10 17 h 8 v -2 h -8 Z m -3 0 q 0.425 0 1 0 Q 8 16.425 8 16 t 0 -1 Q 7.425 15 7 15 t -1 0 Q 6 15.575 6 16 t 0 1 Q 6.575 17 7 17 Z", fill: "#37383d", stroke: "none" })));
const thumbsUpIcon = () => (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" },
  h("g", { fill: "none", stroke: "default", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10" },
    h("path", { "data-color": "color-2", d: "M3.5 15.5h-3v-7h3" }),
    h("path", { d: "M3.5 8.5l3-8h1a1 1 0 011 1v5h4.999a2 2 0 011.927 2.535l-1.389 5A2 2 0 0112.11 15.5H3.5v-7z" }))));
const unlockIcon = () => (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" },
  h("g", { fill: "none", stroke: "default", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10" },
    h("path", { d: "M13.5 15.5h-11a1 1 0 01-1-1v-7a1 1 0 011-1h11a1 1 0 011 1v7a1 1 0 01-1 1zM4.5 6.5V4A3.5 3.5 0 018 .5h0A3.5 3.5 0 0111.355 3" }),
    h("circle", { "data-color": "color-2", cx: "8", cy: "11", r: "1.5" }))));
const infoIcon = () => (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" },
  h("path", { fill: "default", stroke: "none", d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm-.9 3.2h2.1v2.1H7.1V3.2zm3.1 9.2H6v-1h1V8.2H6v-1h3.1v4.1h1v1.1z" })));
const protectIcon = () => (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" },
  h("g", { fill: "none", stroke: "default", "stroke-miterlimit": "10", "stroke-linejoin": "round", "stroke-linecap": "round" },
    h("path", { d: "M13.5 15.5h-11a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1zM4.5 6.5V4a3.5 3.5 0 1 1 7 0v2.5" }),
    h("circle", { cx: "8", cy: "11", r: "1.5" }))));
const removeLockIcon = () => (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" },
  h("g", { fill: "none", stroke: "default", "stroke-linecap": "round", "stroke-linejoin": "round" },
    h("g", { transform: "translate(8 8)", "stroke-miterlimit": "10" },
      h("path", { d: "M1.1 7.5h-7.5c-.6 0-1-.4-1-1v-7c0-.6.4-1 1-1h11c.6 0 1 .4 1 1v2.9M-4.4-1.5V-4c0-1.9 1.6-3.5 3.5-3.5S2.6-5.9 2.6-4v2.5" }),
      h("circle", { cx: "-.9", cy: "3", r: "1.5" })),
    h("path", { d: "m11.1 15.4 4.3-4.3M11.1 11.1l4.3 4.3" }))));

const bmcfvHeaderCss = ".header-title{height:50px;padding-left:19px;font-size:16px;background-color:#ffffff;border-bottom:3px solid #fa6400;font-family:'Knowledge2017-Regular', 'Knowledge2017', sans-serif;display:flex}.header-text{width:100%;align-self:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.header-buttons{display:flex;justify-content:flex-end;flex-basis:500px;height:100%}.header-btn-container{height:100%;padding:0 16px;display:flex;align-items:center}.vertical-line{border-left:1px solid #c1c1c1}.btn-icon{fill:#212121;stroke:#212121;width:32px;height:32px;align-self:center;background-color:transparent;border:0;border-radius:4px;display:inline-block;margin:auto}.btn-icon:hover{cursor:pointer;fill:#93939c;stroke:#93939c}.btn-icon:focus{border:none;outline:none;background:lightgrey}.btn-icon:focus:not(:focus-visible){background:transparent}.btn-icon:focus-visible{box-shadow:0 0 0 2px black;background:transparent}.btn-open{border:none;background-color:transparent;align-items:center;cursor:pointer;height:32px;color:#37383d;display:inline-block;font-size:13px;font-family:Arial, Helvetica Neue, sans-serif;font-weight:700;stroke:#212121;width:max-content;padding-top:3px}.btn-open:hover{color:#93939c;cursor:pointer;stroke:#93939c}.btn-text{vertical-align:top;padding-left:3px}.btn-open.disabled{color:#93939c;stroke:#93939c;cursor:not-allowed}";

const BmcfvHeader$1 = class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.openClicked = createEvent(this, "openClicked", 7);
    this.printClicked = createEvent(this, "printClicked", 7);
    this.closeClicked = createEvent(this, "closeClicked", 7);
    this.downloadClicked = createEvent(this, "downloadClicked", 7);
    this.moveClicked = createEvent(this, "moveClicked", 7);
    this.deleteClicked = createEvent(this, "deleteClicked", 7);
    this.copyClicked = createEvent(this, "copyClicked", 7);
    this.unlockClicked = createEvent(this, "unlockClicked", 7);
    this.renameClicked = createEvent(this, "renameClicked", 7);
    this.approveClicked = createEvent(this, "approveClicked", 7);
    this.sendClicked = createEvent(this, "sendClicked", 7);
    this.insertScanClicked = createEvent(this, "insertScanClicked", 7);
    this.qeIdPrefix = '';
    this.documentName = '';
    this.options = {};
    this.showPrintButton = false;
    this.fileViewerStrings = {};
  }
  render() {
    var _a, _b, _c, _d;
    return (h("div", { class: "header-title" }, h("div", { class: "header-text" }, this.documentName), h("div", { class: "header-buttons" }, ((_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.headerOptions) === null || _b === void 0 ? void 0 : _b.showOpenButton) ? this.openButton() : null, ((_d = (_c = this.options) === null || _c === void 0 ? void 0 : _c.headerOptions) === null || _d === void 0 ? void 0 : _d.showManageDropdown) ? this.managePopover() : null, this.showPrintButton ? this.printButton() : null, this.closeButton())));
  }
  printButton() {
    return (h("div", { class: "header-btn-container" }, h("button", { class: "btn-icon", title: this.fileViewerStrings[TranslationKey.Print], "qe-id": `${this.qeIdPrefix}print-button`, "on-click": () => this.printClicked.emit() }, printIcon())));
  }
  closeButton() {
    return (h("div", { class: "header-btn-container vertical-line" }, h("button", { class: "btn-icon", "qe-id": `${this.qeIdPrefix}close-button`, title: this.fileViewerStrings[TranslationKey.Close], "on-click": () => this.closeClicked.emit() }, closeIcon())));
  }
  openButton() {
    var _a, _b, _c, _d;
    const openBtnClassMap = { 'btn-open': true, disabled: (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.headerOptions) === null || _b === void 0 ? void 0 : _b.openDisabled };
    const buttonDisabled = (_d = (_c = this.options) === null || _c === void 0 ? void 0 : _c.headerOptions) === null || _d === void 0 ? void 0 : _d.openDisabled;
    return (h("div", { class: "header-btn-container" }, h("button", { disabled: buttonDisabled, class: openBtnClassMap, "on-click": () => this.openClicked.emit() }, openIcon(), h("span", { class: "btn-text" }, this.fileViewerStrings[TranslationKey.Open]))));
  }
  managePopover() {
    return (h("div", { class: "header-btn-container" }, h("bmcfv-manage-popover", { options: this.options.headerOptions, "qe-id-prefix": `${this.qeIdPrefix}core-file-viewer-`, fileViewerStrings: this.fileViewerStrings })));
  }
  static get style() { return bmcfvHeaderCss; }
};

var Key;
(function (Key) {
  Key["Tab"] = "Tab";
  Key["Enter"] = "Enter";
  Key["Space"] = " ";
  Key["ArrowUp"] = "ArrowUp";
  Key["ArrowDown"] = "ArrowDown";
  Key["Escape"] = "Escape";
})(Key || (Key = {}));
function preventSideEffects(e) {
  e.preventDefault();
  e.stopImmediatePropagation();
}
function reverseTraversingKeyHandler(e, focusHandler) {
  if (e.shiftKey && e.key === Key.Tab) {
    focusHandler();
    preventSideEffects(e);
  }
}
function lastFocusableKeyHandler(e, focusHandler) {
  if (!e.shiftKey && e.key === Key.Tab) {
    focusHandler();
    preventSideEffects(e);
  }
}
function spaceEnterKeyHandler(e, keyHandler, disabled) {
  if (e.key === Key.Enter || e.key === Key.Space) {
    preventSideEffects(e);
    if (!disabled) {
      keyHandler();
    }
  }
}
function escapeKeyHandler(e, escHandler) {
  if (e.key === Key.Escape) {
    escHandler();
    preventSideEffects(e);
  }
}
/**
 * Arrow navigation handler to "ul" elements with this structure:
 * <ul>
 *  <li>
 * 	 <element/>
 * ...
 */
class ArrowNavigation {
  constructor(customFocus) {
    this.index = -1;
    this.customFocus = customFocus;
  }
  resetIndex() {
    this.index = -1;
  }
  focus(element) {
    if (this.customFocus) {
      this.customFocus(element);
    }
    else {
      element.focus();
    }
  }
  getElementToFocus(listElement, index) {
    const listElementChildren = listElement.children;
    const liElement = listElementChildren[index];
    if (liElement) {
      this.index = index;
      return liElement.firstChild;
    }
    if (index > this.index) {
      this.index = 0;
      return listElementChildren[this.index].firstChild;
    }
    if (index < this.index || index === -1) {
      this.index = listElementChildren.length;
      return listElementChildren[this.index].firstChild;
    }
  }
  resetIndexOnNotArrowKeyPressed(e) {
    if (e.key === Key.Enter || e.key === Key.Space || e.key === Key.Tab || e.key === Key.Escape) {
      this.index = -1;
    }
  }
  arrowNavigationHandler(e, listElement) {
    if (e.key === Key.ArrowDown) {
      const element = this.getElementToFocus(listElement, this.index + 1);
      this.focus(element);
      preventSideEffects(e);
    }
    else if (e.key === Key.ArrowUp) {
      const element = this.getElementToFocus(listElement, this.index - 1);
      this.focus(element);
      preventSideEffects(e);
    }
  }
}

const bmcfvManagePopoverCss = ".manage-btn{border:none;background-color:transparent;align-items:center;cursor:pointer;height:32px;color:#37383d;display:inline-block;font-size:13px;font-family:Arial, Helvetica Neue, sans-serif;font-weight:700;fill:#212121;width:max-content;padding:0}.manage-btn:focus-visible{outline:none;box-shadow:0 0 0 2px black;border-radius:4px}.manage-btn:hover{color:#93939c;cursor:pointer;fill:#93939c}.manage-menu-button.disabled{color:#93939c;stroke:#93939c;cursor:not-allowed;fill:none}.btn-text{vertical-align:top;padding-left:5px;padding-right:3px}.popover-wrapper{position:relative;display:inline-block}li>button{background-color:transparent;border:none;width:100%;height:100%;text-align:left;padding:0 20px;color:#37383d;font-family:Arial, Helvetica Neue, sans-serif;font-weight:700;font-size:14px;cursor:pointer;stroke:#212121}ul.open:focus,ul.open:focus-within,ul.open:hover{z-index:10;opacity:1;height:auto}ul{box-shadow:0 6px 12px rgb(0 0 0 / 18%);background:#fff;padding:0;border:1px solid #b2b2b8;max-height:450px;overflow-y:auto;overflow-x:hidden;margin-top:1px;display:block;border-radius:0;z-index:-1;min-width:160px;height:0px;opacity:0;position:absolute;top:120%;right:-70px}li{height:36px;line-height:36px;width:100%;border-right:none;display:flex;text-decoration:none;clear:both;white-space:nowrap}ul:focus{outline:none}li button:hover,li button:focus:not(.disabled){background-color:#d5ecf4;outline:none}li.disabled,li.aria-disabled{color:#93939c;stroke:#93939c;fill:#93939c;cursor:not-allowed}.manage-menu-button.disabled .insert-scan path{fill:rgb(147, 147, 156)}";

const BmcfvManagePopover$1 = class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.downloadClicked = createEvent(this, "downloadClicked", 7);
    this.sendClicked = createEvent(this, "sendClicked", 7);
    this.moveClicked = createEvent(this, "moveClicked", 7);
    this.copyClicked = createEvent(this, "copyClicked", 7);
    this.deleteClicked = createEvent(this, "deleteClicked", 7);
    this.renameClicked = createEvent(this, "renameClicked", 7);
    this.insertScanClicked = createEvent(this, "insertScanClicked", 7);
    this.unlockClicked = createEvent(this, "unlockClicked", 7);
    this.approveClicked = createEvent(this, "approveClicked", 7);
    this.propertiesClicked = createEvent(this, "propertiesClicked", 7);
    this.removeLockClicked = createEvent(this, "removeLockClicked", 7);
    this.unprotectClicked = createEvent(this, "unprotectClicked", 7);
    this.protectClicked = createEvent(this, "protectClicked", 7);
    this.arrowNavigation = new ArrowNavigation();
    this.qeIdPrefix = '';
    this.options = {};
    this.fileViewerStrings = undefined;
  }
  render() {
    const manageDropdownButtons = this.getDropdownButtons().map(this.renderButton.bind(this));
    return (h("div", { class: "popover-wrapper", onKeyDown: this.toggleDropDownOnKeyPressed.bind(this) }, h("button", { class: "manage-btn", onMouseDown: this.toggleDropDownPreventingDefault.bind(this) }, h("span", { class: "btn-text" }, this.fileViewerStrings[TranslationKey.Manage]), caretDownFilledIcon()), h("ul", { id: "manage-menu", role: "menu", tabIndex: -1, onKeyDown: this.arrowKeyNavigationHandler.bind(this), ref: el => {
        this.manageDropdown = el;
      } }, manageDropdownButtons)));
  }
  toggleDropDown() {
    const openClass = 'open';
    const classList = this.manageDropdown.classList;
    const height = window.getComputedStyle(this.manageDropdown).height;
    if (!classList.contains(openClass)) {
      this.manageDropdown.focus();
      classList.add(openClass);
      // if drop-down is visible we remove 'open' class in order to collapse it.
      // Otherwise if drop-down is not visible (it was closed with outside click)
      // we do not remove 'open' class so we show it on manage btn click
      // eslint-disable-next-line no-negated-condition
    }
    else if (height !== '0px') {
      classList.remove(openClass);
    }
    else {
      this.manageDropdown.focus();
    }
  }
  toggleDropDownOnKeyPressed(e) {
    this.arrowNavigation.resetIndexOnNotArrowKeyPressed(e);
    spaceEnterKeyHandler(e, this.toggleDropDown.bind(this));
  }
  toggleDropDownPreventingDefault(e) {
    this.toggleDropDown();
    e.preventDefault();
    e.stopImmediatePropagation();
  }
  arrowKeyNavigationHandler(e) {
    this.arrowNavigation.arrowNavigationHandler(e, this.manageDropdown);
    escapeKeyHandler(e, this.toggleDropDown.bind(this));
  }
  /**
    *Aria disabled is not supported on mozilla, we are getting it by parameters until it is supported.
    when it gets supported we can use event.target.ariaDisabled
  */
  onClickButtonHandler(handler, disabled) {
    if (!disabled) {
      return void handler();
    }
  }
  renderButton(item, index) {
    const disabledButtonStyle = { 'manage-menu-button': true, disabled: item.disabled };
    const ariaDisabled = item.disabled ? 'true' : 'false';
    if (item.show) {
      return (h("li", { role: "menuitem" }, h("button", { tabIndex: -1, onMouseOver: () => (this.arrowNavigation.index = index), onKeyDown: e => spaceEnterKeyHandler(e, item.handler, item.disabled), "on-click": () => this.onClickButtonHandler(item.handler, item.disabled), class: disabledButtonStyle, "aria-disabled": ariaDisabled, "qe-id": `${this.qeIdPrefix}${item.qeId}` }, item.icon(), h("span", { class: "btn-text" }, item.title))));
    }
  }
  getDropdownButtons() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
    return [
      {
        title: this.fileViewerStrings[TranslationKey.Download],
        icon: downloadIcon,
        show: (_a = this.options) === null || _a === void 0 ? void 0 : _a.showDownloadOption,
        disabled: (_b = this.options) === null || _b === void 0 ? void 0 : _b.downloadDisabled,
        handler: () => this.downloadClicked.emit(),
        qeId: 'download-option',
      },
      {
        title: this.fileViewerStrings[TranslationKey.Send],
        icon: envelopeIcon,
        show: (_c = this.options) === null || _c === void 0 ? void 0 : _c.showSendOption,
        disabled: (_d = this.options) === null || _d === void 0 ? void 0 : _d.sendDisabled,
        handler: () => this.sendClicked.emit(),
        qeId: 'send-option',
      },
      {
        title: this.fileViewerStrings[TranslationKey.Move],
        icon: moveIcon,
        show: (_e = this.options) === null || _e === void 0 ? void 0 : _e.showMoveOption,
        disabled: (_f = this.options) === null || _f === void 0 ? void 0 : _f.moveDisabled,
        handler: () => this.moveClicked.emit(),
        qeId: 'move-option',
      },
      {
        title: this.fileViewerStrings[TranslationKey.Copy],
        icon: copyIcon,
        show: (_g = this.options) === null || _g === void 0 ? void 0 : _g.showCopyOption,
        disabled: (_h = this.options) === null || _h === void 0 ? void 0 : _h.copyDisabled,
        handler: () => this.copyClicked.emit(),
        qeId: 'copy-option',
      },
      {
        title: this.fileViewerStrings[TranslationKey.Rename],
        icon: renameIcon,
        show: (_j = this.options) === null || _j === void 0 ? void 0 : _j.showRenameOption,
        disabled: (_k = this.options) === null || _k === void 0 ? void 0 : _k.renameDisabled,
        handler: () => this.renameClicked.emit(),
        qeId: 'rename-option',
      },
      {
        title: this.fileViewerStrings[TranslationKey.InsertScan],
        icon: insertScanIcon,
        show: (_l = this.options) === null || _l === void 0 ? void 0 : _l.showInsertScanOption,
        disabled: (_m = this.options) === null || _m === void 0 ? void 0 : _m.insertScanDisabled,
        handler: () => this.insertScanClicked.emit(),
        qeId: 'insert-scan-option',
      },
      {
        title: this.fileViewerStrings[TranslationKey.Delete],
        icon: removeIcon,
        show: (_o = this.options) === null || _o === void 0 ? void 0 : _o.showDeleteOption,
        disabled: (_p = this.options) === null || _p === void 0 ? void 0 : _p.deleteDisabled,
        handler: () => this.deleteClicked.emit(),
        qeId: 'delete-option',
      },
      {
        title: this.fileViewerStrings[TranslationKey.Unlock],
        icon: unlockIcon,
        show: (_q = this.options) === null || _q === void 0 ? void 0 : _q.showUnlockOption,
        disabled: (_r = this.options) === null || _r === void 0 ? void 0 : _r.unlockDisabled,
        handler: () => this.unlockClicked.emit(),
        qeId: 'unlock-option',
      },
      {
        title: this.fileViewerStrings[TranslationKey.Approve],
        icon: thumbsUpIcon,
        show: (_s = this.options) === null || _s === void 0 ? void 0 : _s.showApproveOption,
        disabled: (_t = this.options) === null || _t === void 0 ? void 0 : _t.approveDisabled,
        handler: () => this.approveClicked.emit(),
        qeId: 'approve-option',
      },
      {
        title: this.fileViewerStrings[TranslationKey.Protect],
        icon: protectIcon,
        show: (_u = this.options) === null || _u === void 0 ? void 0 : _u.showProtectOption,
        disabled: (_v = this.options) === null || _v === void 0 ? void 0 : _v.protectDisabled,
        handler: () => this.protectClicked.emit(),
        qeId: 'protect-option',
      },
      {
        title: this.fileViewerStrings[TranslationKey.Unprotect],
        icon: unlockIcon,
        show: (_w = this.options) === null || _w === void 0 ? void 0 : _w.showUnprotectOption,
        disabled: (_x = this.options) === null || _x === void 0 ? void 0 : _x.unprotectDisabled,
        handler: () => this.unprotectClicked.emit(),
        qeId: 'unprotect-option',
      },
      {
        title: this.fileViewerStrings[TranslationKey.RemoveLock],
        icon: removeLockIcon,
        show: (_y = this.options) === null || _y === void 0 ? void 0 : _y.showRemoveLockOption,
        disabled: (_z = this.options) === null || _z === void 0 ? void 0 : _z.removeLockDisabled,
        handler: () => this.removeLockClicked.emit(),
        qeId: 'remove-lock-option',
      },
      {
        title: this.fileViewerStrings[TranslationKey.Properties],
        icon: infoIcon,
        show: (_0 = this.options) === null || _0 === void 0 ? void 0 : _0.showPropertiesOption,
        disabled: (_1 = this.options) === null || _1 === void 0 ? void 0 : _1.propertiesDisabled,
        handler: () => this.propertiesClicked.emit(),
        qeId: 'properties-option',
      },
    ];
  }
  static get style() { return bmcfvManagePopoverCss; }
};

const BmcfvModalTemplate$1 = class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.closeButtonClick = createEvent(this, "closeButtonClick", 7);
    this.contentHeight = 0;
    this.modalId = '';
    this.modalTitle = '';
    this.closeButtonQeId = '';
  }
  render() {
    const cssRootClass = 'modal-with-overlay-' + this.modalId;
    const topDistance = this.modalId === "watermark" ? 90 : 30;
    return (h("div", { ref: el => this.storeModalElement(el), class: cssRootClass, style: this.getRootStyle() }, this.modalId ? (h("style", null, `  .${cssRootClass} .modal-dialog-${this.modalId} {
							top: calc(50% - ${(this.contentHeight + topDistance) / 2}px);
							position: fixed;
							display: flex;
							flex-direction: column;
							background-color: rgb(255, 255, 255);

							border: 1px solid rgb(178, 178, 184);
							padding: 0px 16px 16px;
							box-sizing: border-box;
							box-shadow: rgb(0 0 0 / 20%) 0px 0px 15px;
							max-width: none;
							max-height: calc(100vh - 50px);
							overflow: auto;
							outline: none;
						}

						.${cssRootClass} .modal-dialog-${this.modalId}-content {
							height: ${this.contentHeight}px;
						}

						.${cssRootClass} .modal-dialog-${this.modalId}-header {
							display: flex;
							justify-content: space-between;
							margin-bottom: 20px;
							padding-bottom: 0px;
							border-bottom: 1px solid rgb(147, 147, 147);
							height: 64px;
						}

						.${cssRootClass} .modal-dialog-${this.modalId}-header h3.title {
							font-family: KnowledgeRegular, arial, helvetica, sans-serif;
							font-weight: 400;
							font-size: 26px;
							padding: 0px;
							color: rgb(31, 31, 31);
							margin: auto 0px;
						}

						.${cssRootClass} .modal-dialog-${this.modalId}-header .close-icon {
							margin: auto 0px;
							line-height: 0;
						}

						.${cssRootClass} .modal-dialog-${this.modalId}-header svg {
							width: 17px;
							height: 17px;
							zoom: 1;
							fill: rgb(64, 64, 64);
						}

						.${cssRootClass} .modal-dialog-${this.modalId}-header svg:hover {
							fill: rgb(147, 147, 156);
							cursor: pointer;
							color: rgb(147, 147, 156);
						}
						`)) : null, h("div", { class: "core-viewer-modal-overlay", style: this.getOverlayStyle() }), h("div", { ref: el => this.storeModalDialog(el), onKeyDown: e => this.closeOnEscape(e), class: `modal-dialog-${this.modalId}`, tabindex: '-1', style: this.getHighestZIndexStyle() }, h("div", { class: `modal-dialog-${this.modalId}-header` }, h("h3", { class: "title" }, this.modalTitle), h("div", { ref: el => this.storeCloseButton(el), onKeyDown: (e) => this.closeButtonKeyDownHandler(e), onKeyPress: e => this.closeButtonKeyPressHandler(e), class: "close-icon", tabindex: "0", "qe-id": this.closeButtonQeId, onClick: () => {
        this.closeHandler();
      } }, h("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, h("path", { d: "M30 4.8l-2.8-2.8-11.2 11.2-11.2-11.2-2.8 2.8 11.2 11.2-11.2 11.2 2.8 2.8 11.2-11.2 11.2 11.2 2.8-2.8-11.2-11.2z" })))), h("div", { ref: el => {
        this.containerElement = el;
      }, class: `modal-dialog-content-${this.modalId}` }, h("slot", null)))));
  }
  closeOnEscape(e) {
    e.stopPropagation();
    if (e.key === "Escape") {
      this.closeHandler();
    }
  }
  closeButtonKeyDownHandler(e) {
    reverseTraversingKeyHandler(e, () => {
      const focusLastElement = this.modalContentElement.focusLastElement;
      if (focusLastElement instanceof Function) {
        focusLastElement();
      }
    });
  }
  closeButtonKeyPressHandler(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      this.closeHandler();
    }
  }
  closeHandler() {
    this.closeButtonClick.emit();
    const cancelHandler = this.modalContentElement.cancelHandler;
    if (cancelHandler instanceof Function) {
      cancelHandler.call(this.modalContentElement);
    }
  }
  storeModalElement(el) {
    this.modalElement = el;
    el.addEventListener('lastElementPassedFocus', () => {
      this.closeButton.focus();
    });
  }
  storeCloseButton(el) {
    this.closeButton = el;
    if (this.closeButton.focus instanceof Function) {
      this.closeButton.focus();
    }
  }
  storeModalDialog(el) {
    this.modalDialog = el;
  }
  componentDidLoad() {
    window.document.body.appendChild(this.modalElement);
    this.modalContentElement = this.containerElement.firstElementChild;
    if (this.modalDialog.focus instanceof Function) {
      this.modalDialog.focus();
    }
  }
  disconnectedCallback() {
    window.document.body.removeChild(this.modalElement);
  }
  getOverlayStyle() {
    return Object.assign({ display: 'flex', position: 'fixed', top: '0', left: '0', 'align-items': 'center', 'justify-content': 'center', width: '100%', height: '100%', opacity: '0.3', 'background-color': 'rgba(0, 0, 0, 0.87)' }, this.getHighestZIndexStyle());
  }
  getHighestZIndexStyle() {
    return {
      'z-index': String(getHigherZIndex() + 1),
    };
  }
  getRootStyle() {
    return {
      'z-index': String(getHigherZIndex() + 1),
      'flex-direction': 'column',
      display: 'flex',
      'align-items': 'center',
    };
  }
};

const bmcfvPrintOptionsCss = ".print-options{opacity:1.0;box-sizing:border-box;background-color:#ffffff;display:block;flex-direction:column;justify-content:space-around;position:relative;width:566px;color:rgb(255, 255, 255)}.checkbox-container{margin-bottom:16px;font-size:14px;font-family:Arial, Helvetica, sans-serif;color:#1f1f1f;display:block;position:relative;padding-left:21px;line-height:1;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.checkbox-label{display:inline-block}.checkbox-container input{position:absolute;cursor:default;opacity:0;height:0;width:0}.check-box{position:absolute;top:0px;left:0px;height:12px;width:12px;border:1px solid #404040;background-color:#ffffff}.checkbox-container input:focus~.check-box{box-shadow:0 0 0 1px #000}.check-mark{position:absolute;top:0px;left:0px;height:12px;width:0px;opacity:1;display:block;overflow:hidden}.checkbox-container input:checked~.check-box .check-mark{width:12px;transition:width 0.4s}.check-mark:after{content:'';position:absolute;display:block;left:4px;top:0px;width:3px;height:9px;border-style:solid;border-color:#404040;border-image:initial;border-width:0px 1px 1px 0px;transform:rotate(45deg)}.checkbox-container.disabled{pointer-events:none}.checkbox-container.disabled .check-box,.checkbox-container.disabled .check-mark:after{border-color:#afafaf}.btn{padding:0 16px;font-size:14px;height:30px;line-height:30px;letter-spacing:0.28px;max-width:100%;min-width:88px;white-space:nowrap;overflow:hidden;border-radius:5px;align-items:center;border-style:solid;border-width:1px;display:inline-flex;font-family:BentoRegular, arial, helvetica, sans-serif;font-weight:400;justify-content:center;transition:color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\n\t\tbox-shadow 0.15s ease-in-out;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;vertical-align:middle}.btn-primary{color:#fff;background-color:#666;border-color:#666}.btn-primary.focus,.btn-primary:focus{text-decoration:none;color:#fff;border-color:#fff;outline:none;box-shadow:0 0 0 1px #383838 !important;z-index:1}.btn-primary:hover{text-decoration:none;color:#fff;background-color:#2c2c2c;border-color:#2c2c2c}.btn.focus,.btn:focus{outline:0;box-shadow:0 0 0 0.2rem rgb(0 123 255 / 25%)}.btn:focus,.btn:hover{ext-decoration:none}.btn:not(:disabled):not(.disabled){cursor:pointer}.btn-outline-primary:focus{color:#292929;border-color:#121212;box-shadow:0 0 0 1px #121212}.btn-primary.disabled,.btn-primary:disabled,.btn-primary[disabled]{pointer-events:none;cursor:default;transform:translateZ(0);background-color:#f4f5f7;color:#939393;border-color:#afafaf;opacity:1}.btn.disabled,.btn:disabled{opacity:1}.watermark-link{margin:24px 0px 32px 0px}.watermark-link-without-checkboxes{margin:4px 0px 32px 0px}.footer{border-top:1px solid #939393;padding:24px 0px 9px 0px;outline:none}a{font-family:Arial;font-size:14px;color:#005da2;cursor:pointer;text-decoration:underline}a:hover{color:#02406e}a.disabled{color:black;opacity:0.5;text-decoration:none;pointer-events:none}bmcfv-busy-loader.common-file-viewer-busy-loader{padding:0 0 0 5px;width:25px;height:25px}";

const BmcfvPrintOptions$1 = class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.watermarkModalRequested = createEvent(this, "watermarkModalRequested", 7);
    this.print = createEvent(this, "print", 7);
    this.lastElementPassedFocus = createEvent(this, "lastElementPassedFocus", 7);
    this.annotationsAllowed = true;
    this.fileViewerStrings = {};
    this.showBusyLoader = undefined;
  }
  render() {
    return [
      h("div", { class: "print-options" }, this.annotationsAllowed
        ? [
          h("div", { class: { 'checkbox-container': true, disabled: this.showBusyLoader } }, h("label", { class: "checkbox-label" }, h("input", { ref: (el) => { this.includeAnnotationsInput = el; }, type: "checkbox", checked: true, id: "include-annotations", disabled: this.showBusyLoader }), h("span", { class: "check-box" }, h("span", { class: "check-mark" })), this.fileViewerStrings[TranslationKey.IncludeAnnotations])),
          h("div", { class: { 'checkbox-container': true, disabled: this.showBusyLoader } }, h("label", { class: "checkbox-label" }, h("input", { ref: (el) => { this.includeCommentsInput = el; }, type: "checkbox", id: "include-comments", disabled: this.showBusyLoader }), h("span", { class: "check-box" }, h("span", { class: "check-mark" })), this.fileViewerStrings[TranslationKey.IncludeComments]))
        ]
        : null, h("div", { class: this.annotationsAllowed ? "watermark-link" : "watermark-link-without-checkboxes" }, h("a", { onClick: (ev) => this.openWatermarkModalHandler(ev), tabindex: "0", href: "#", class: { disabled: this.showBusyLoader } }, this.fileViewerStrings[TranslationKey.AddWatermark])), h("div", { class: "footer", tabindex: "-1" }, h("button", { id: "print-btn", ref: (el) => { this.printButton = el; }, class: this.showBusyLoader ? "btn btn-primary btn-lg disabled" : "btn btn-primary btn-lg", onClick: () => this.printClicked(), onKeyDown: (e) => lastFocusableKeyHandler(e, () => this.lastElementPassedFocus.emit()) }, this.fileViewerStrings[TranslationKey.Print], this.showBusyLoader ? this.busyLoader() : null))),
    ];
  }
  busyLoader() {
    return (h("bmcfv-busy-loader", { class: "common-file-viewer-busy-loader" }));
  }
  printClicked() {
    var _a, _b;
    const includeAnnotations = !!((_a = this.includeAnnotationsInput) === null || _a === void 0 ? void 0 : _a.checked);
    const includeComments = !!((_b = this.includeCommentsInput) === null || _b === void 0 ? void 0 : _b.checked);
    this.print.emit({ includeAnnotations, includeComments });
  }
  openWatermarkModalHandler(event) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();
    this.watermarkModalRequested.emit();
  }
  focusLastElement() {
    this.printButton.focus();
  }
  static get style() { return bmcfvPrintOptionsCss; }
};

const Fonts = [
  'Arial',
  'Times New Roman',
  'Tahoma',
  'Trebuchet MS',
  'Courier',
  'Verdana',
  'Georgia',
  'Palatino',
  'Comic Sans MS',
  'Arial Black',
  'Impact',
];
const FontSizes = [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48];
var TextStyles;
(function (TextStyles) {
  TextStyles["bold"] = "BOLD";
  TextStyles["italic"] = "ITALIC";
  TextStyles["underline"] = "UNDERLINE";
})(TextStyles || (TextStyles = {}));
var WatermarkLocation;
(function (WatermarkLocation) {
  WatermarkLocation["Center"] = "diagonal";
  WatermarkLocation["TopLeft"] = "headerLeft";
  WatermarkLocation["TopRight"] = "headerRight";
  WatermarkLocation["TopCenter"] = "headerCenter";
  WatermarkLocation["BottomLeft"] = "footerLeft";
  WatermarkLocation["BottomRight"] = "footerRight";
  WatermarkLocation["BottomCenter"] = "footerCenter";
})(WatermarkLocation || (WatermarkLocation = {}));
var AriaLabels;
(function (AriaLabels) {
  AriaLabels["bold"] = "Bold";
  AriaLabels["italic"] = "Italic";
  AriaLabels["underline"] = "Underline";
  AriaLabels["highlight"] = "Highlight";
})(AriaLabels || (AriaLabels = {}));

const bmcfvWatermarkOptionsCss = ".watermark-options{opacity:1.0;box-sizing:border-box;background-color:#ffffff;display:flex;flex-direction:column;justify-content:space-around;position:relative;width:570px;color:rgb(255, 255, 255)}select,input[type='text']{box-sizing:border-box;width:212px;font-size:14px;height:30px;color:#1f1f1f;border:solid 1px #939393}select:focus,input[type='text']:focus{border:solid 1px #272727;outline:none}input[type='range']{width:160px;background:linear-gradient(#212121, #212121);border:solid 1px transparent;border-radius:8px;height:1px;outline:none;transition:'background 450ms ease-in';appearance:none;cursor:pointer}input[type='range']:focus-visible{height:2px}input[type='range']::-webkit-slider-thumb{appearance:none;border:none;height:10px;width:10px;border-radius:50%;background:#212121;cursor:pointer}input[type='range']::-moz-range-thumb{border:none;height:10px;width:10px;border-radius:50%;background:#212121;cursor:pointer}input[type='range']::-ms-thumb{border:none;height:10px;width:10px;border-radius:50%;background:#212121;cursor:pointer}.opacity-container{width:212px}.opacity-label{float:right;display:inline-block}.style-button{padding:0;border:none;background-color:transparent;position:relative;display:flex;justify-content:center;align-items:center;cursor:pointer;border-radius:4px;width:32px;height:32px;color:#868e96}.style-button.selected{background-color:rgb(239, 239, 239);border-radius:5px}.icon{width:16px;height:16px;pointer-events:none}.style-item{display:inline-block}.row{display:flex;outline:none}.column{flex:50%}.column>label,.font-styles-container{margin-top:16px;display:inline-block;color:#1f1f1f;font-size:14px}.column>label.text-container{margin-top:20px}.column>label.placement-container{margin-top:0px;padding-bottom:20px;border-bottom:1px solid #939393;width:212px}.restore-default-settings-container{display:block;width:212px;border-top:1px solid #939393;padding:20px 0px;margin-top:10px}.footer{border-top:1px solid #939393;padding:25px 0px 9px 0px}.cancel-button{margin-left:20px}#canvas-container{height:418px;max-width:283px;padding-right:24px;display:flex}.styles-container{padding-top:5px}#canvas-container canvas{border:1px solid #939393;margin:auto;box-sizing:border-box}.style-popup{position:absolute;background:#f8f9fa;display:flex;flex-direction:column;justify-content:center;border-radius:0px 0px 4px 4px;box-shadow:0 0 3px 0 #adb5bd;align-items:center;width:212px;padding:4px 12px 8px 12px}.btn{padding:0 16px;font-size:14px;height:30px;line-height:30px;letter-spacing:0.28px;max-width:100%;min-width:88px;white-space:nowrap;overflow:hidden;border-radius:5px;align-items:center;border-style:solid;border-width:1px;display:inline-flex;font-family:BentoRegular, arial, helvetica, sans-serif;font-weight:400;justify-content:center;transition:color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\n\t\tbox-shadow 0.15s ease-in-out;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;vertical-align:middle}.btn-primary{color:#fff;background-color:#666;border-color:#666}.btn-primary.focus,.btn-primary:focus{text-decoration:none;color:#fff;border-color:#fff;outline:none;box-shadow:0 0 0 1px #383838 !important;z-index:1}.btn-primary:hover{text-decoration:none;color:#fff;background-color:#2c2c2c;border-color:#2c2c2c}.btn.focus,.btn:focus{outline:0;box-shadow:0 0 0 0.2rem rgb(0 123 255 / 25%)}.btn:focus,.btn:hover{ext-decoration:none}.btn:not(:disabled):not(.disabled){cursor:pointer}.btn-outline-primary:focus{color:#292929;border-color:#121212;box-shadow:0 0 0 1px #121212}.btn-primary.disabled,.btn-primary:disabled,.btn-primary[disabled]{pointer-events:none;cursor:default;transform:translateZ(0);background-color:#f4f5f7;color:#939393;border-color:#afafaf;opacity:1}.btn.disabled,.btn:disabled{opacity:1}";

const BmcfvWatermarkOptions$1 = class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.closed = createEvent(this, "closed", 7);
    this.watermarkChanged = createEvent(this, "watermarkChanged", 7);
    this.lastElementPassedFocus = createEvent(this, "lastElementPassedFocus", 7);
    this.initialWatermarkOptions = this.getDefaultWatermarkOptions();
    this.watermarkSettings = undefined;
    this.watermarkLocation = WatermarkLocation.Center;
    this.isColorPaletteVisible = false;
    this.fileViewerStrings = {};
  }
  componentDidLoad() {
    this.updateWatermark();
    if (this.watermarkSettings) {
      this.initialWatermarkOptions = {};
      for (const watermarkLocation of Object.values(WatermarkLocation)) {
        this.initialWatermarkOptions[watermarkLocation] = Object.assign(Object.assign({}, this.watermarkSettings[watermarkLocation]), { fontStyles: [...this.watermarkSettings[watermarkLocation].fontStyles] });
      }
    }
  }
  render() {
    var _a, _b;
    this.watermarkSettings = (_a = this.watermarkSettings) !== null && _a !== void 0 ? _a : this.getDefaultWatermarkOptions();
    const locations = Object.keys(WatermarkLocation).map(item => {
      const locationKey = item;
      return (h("option", { selected: this.ifDefined(WatermarkLocation[locationKey] === this.watermarkLocation ? 'selected' : undefined), value: WatermarkLocation[locationKey] }, this.fileViewerStrings[`CommonFileViewer.WatermarkModal.${locationKey}`]));
    });
    const options = Object.assign({}, this.watermarkSettings[this.watermarkLocation]);
    const sizes = FontSizes.map(item => h("option", { selected: this.ifDefined(item === options.fontSize ? 'selected' : undefined), value: item }, item));
    const fonts = Fonts.map(item => h("option", { selected: this.ifDefined(item === options.fontFamily ? 'selected' : undefined), value: item }, item));
    const fontStyles = options.fontStyles;
    const boldStyleClassMap = fontStyles.includes(TextStyles.bold) ? { 'style-button': true, selected: true } : { 'style-button': true };
    const italicStyleClassMap = fontStyles.includes(TextStyles.italic) ? { 'style-button': true, selected: true } : { 'style-button': true };
    const underlineStyleClassMap = fontStyles.includes(TextStyles.underline) ? { 'style-button': true, selected: true } : { 'style-button': true };
    return h("div", { class: "watermark-options" }, h("div", { class: "row", tabindex: "-1" }, h("div", { class: "column" }, h("label", { class: "placement-container" }, this.fileViewerStrings[TranslationKey.WatermarkModalPlacement], h("br", null), h("select", { ref: (el) => { this.locationsSelect = el; }, id: "locations", "data-qe-id": "watermark-modal-placement-select", name: "locations", onChange: () => this.changeWatermarkLocationHandler() }, locations)), h("label", { class: "text-container" }, this.fileViewerStrings[TranslationKey.WatermarkModalText], h("br", null), h("input", { ref: (el) => { this.textInput = el; }, id: "text", "data-qe-id": "watermark-modal-text-input", type: "text", value: options.text, onInput: () => this.changeWatermarkOptionsHandler() })), h("label", null, this.fileViewerStrings[TranslationKey.WatermarkModalFont], h("br", null), h("select", { ref: (el) => { this.fontsInput = el; }, id: "fonts", "data-qe-id": "watermark-modal-fonts-select", name: "fonts", onChange: () => this.changeWatermarkOptionsHandler() }, fonts)), h("label", null, this.fileViewerStrings[TranslationKey.WatermarkModalSize], h("br", null), h("select", { ref: (el) => { this.sizeSelect = el; }, id: "sizes", "data-qe-id": "watermark-modal-size-select", name: "sizes", onChange: () => this.changeWatermarkOptionsHandler() }, sizes)), h("label", { class: "opacity-container" }, h("label", null, this.fileViewerStrings[TranslationKey.WatermarkModalOpacity], h("br", null), h("input", { role: "button", ref: (el) => { this.opacityInput = el; }, id: "opacity", "data-qe-id": "watermark-modal-opacity-slider", type: "range", min: "0", max: "100", value: options.opacity, onInput: () => this.changeWatermarkOptionsHandler() })), h("span", { class: "opacity-label" }, (_b = options.opacity) !== null && _b !== void 0 ? _b : 0, "%")), h("div", { class: "font-styles-container" }, this.fileViewerStrings[TranslationKey.WatermarkModalFontStyle], h("br", null), h("div", { class: "styles-container" }, h("div", { class: "style-item" }, h("button", { id: "color-icon", "data-qe-id": "watermark-modal-color-input", "aria-label": AriaLabels.highlight, class: "style-button", onClick: () => this.setColorPaletteVisibility(!this.isColorPaletteVisible) }, h("div", { class: "icon", style: { 'fill': options.color, 'stroke': options.color } }, h("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, h("g", { fill: "default", stroke: "default", "stroke-linecap": "round", "stroke-linejoin": "round" }, h("path", { "data-color": "color-2", d: "M1 25h30v6H1z", "stroke-width": "2" }), h("path", { fill: "none", d: "M23 19L17 1h-2L9 19", "stroke-width": "2" }), h("path", { d: "M7 19h6M19 19h6M11.666 11h8.668", "stroke-width": "2" })))))), h("div", { class: "style-item" }, h("button", { id: "bold-icon", class: boldStyleClassMap, "data-qe-id": "watermark-modal-bold-style-button", "aria-label": AriaLabels.bold, onClick: () => this.styleButtonClickHandler(TextStyles.bold) }, h("div", { class: "icon" }, h("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, h("g", { stroke: "#1f1f1f", fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round" }, h("path", { d: "M5 3h12a6 6 0 016 6h0a6 6 0 01-6 6H9M9 15h11a7 7 0 017 7h0a7 7 0 01-7 7H5M9 3v26", "stroke-width": "3" })))))), h("div", { class: "style-item" }, h("button", { id: "italic-icon", class: italicStyleClassMap, "data-qe-id": "watermark-modal-italic-style-button", "aria-label": AriaLabels.italic, onClick: () => this.styleButtonClickHandler(TextStyles.italic) }, h("div", { class: "icon" }, h("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, h("g", { stroke: "#1f1f1f", fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round" }, h("path", { d: "M13 1h12M7 31h12M19 1l-6 30", "stroke-width": "2" })))))), h("div", { class: "style-item" }, h("button", { id: "underline-icon", class: underlineStyleClassMap, "data-qe-id": "watermark-modal-underline-style-button", "aria-label": AriaLabels.underline, onClick: () => this.styleButtonClickHandler(TextStyles.underline) }, h("div", { class: "icon" }, h("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, h("g", { stroke: "#1f1f1f", fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round" }, h("path", { "data-color": "color-2", d: "M1 31h30", "stroke-width": "2" }), h("path", { d: "M25 3v13a9 9 0 01-9 9h0a9 9 0 01-9-9V3M3 3h8M21 3h8", "stroke-width": "2" })))))))), this.isColorPaletteVisible
      ? h("div", { class: "style-popup", id: "style-popup", onClick: () => this.setColorPaletteVisibility(false) }, h("bmcfv-color-palette", { onColorChanged: (e) => this.setActiveColor(e), currentColor: options.color }))
      : null, h("div", { class: "restore-default-settings-container" }, h("button", { class: "btn btn-outline-primary", "data-qe-id": "watermark-modal-restore-default-settings-button", onClick: () => this.resetAllOptionsHandler() }, this.fileViewerStrings[TranslationKey.WatermarkModalRestoreDefaultSettings]))), h("div", { class: "column" }, h("div", { ref: (el) => { this.canvasContainerDiv = el; }, id: "canvas-container" }))), h("div", { class: "footer" }, h("button", { class: "btn btn-primary", "data-qe-id": "watermark-modal-add-button", onClick: () => this.closeHandler() }, this.fileViewerStrings[TranslationKey.WatermarkModalAdd]), h("button", { id: "watermark-modal-cancel-btn", ref: (el) => { this.cancelButton = el; }, class: "btn btn-outline-primary cancel-button", "data-qe-id": "watermark-modal-cancel-button", onClick: () => this.cancelHandler(), onKeyDown: (e) => lastFocusableKeyHandler(e, () => this.lastElementPassedFocus.emit()) }, this.fileViewerStrings[TranslationKey.WatermarkModalCancel])));
  }
  ifDefined(arg0) {
    return !!arg0 && arg0 !== '';
  }
  closeHandler() {
    this.closed.emit();
  }
  cancelHandler() {
    this.watermarkSettings = this.createDeepCopy(this.initialWatermarkOptions);
    this.updateWatermark();
    this.closeHandler();
  }
  resetAllOptionsHandler() {
    this.watermarkSettings = this.createDeepCopy(this.getDefaultWatermarkOptions());
    this.watermarkLocation = WatermarkLocation.Center;
    this.fillRange();
    this.updateWatermark();
  }
  changeWatermarkOptionsHandler() {
    this.watermarkSettings[this.watermarkLocation] = Object.assign(Object.assign({}, this.watermarkSettings[this.watermarkLocation]), { text: this.textInput.value, fontSize: Number(this.sizeSelect.value), fontFamily: this.fontsInput.value, opacity: Number(this.opacityInput.value) });
    this.fillRange();
    this.updateWatermark();
  }
  changeWatermarkLocationHandler() {
    this.watermarkLocation = this.locationsSelect.value;
    this.fillRange();
  }
  focusLastElement() {
    this.cancelButton.focus();
  }
  createDeepCopy(defaultWatermarkOptions) {
    return JSON.parse(JSON.stringify(defaultWatermarkOptions));
  }
  styleButtonClickHandler(textStyle) {
    const fontStyles = this.watermarkSettings[this.watermarkLocation].fontStyles;
    if (fontStyles.includes(textStyle)) {
      this.watermarkSettings[this.watermarkLocation].fontStyles = fontStyles.filter(item => item !== textStyle);
    }
    else {
      fontStyles.push(textStyle);
    }
    this.updateWatermark();
  }
  updateWatermark() {
    const canvasContainer = this.canvasContainerDiv;
    this.watermarkChanged.emit({ options: this.watermarkSettings, canvasContainer });
  }
  setColorPaletteVisibility(visible) {
    this.isColorPaletteVisible = visible;
  }
  setActiveColor(e) {
    this.watermarkSettings[this.watermarkLocation].color = e.detail;
    this.changeWatermarkOptionsHandler();
  }
  getDefaultWatermarkOptions() {
    const options = {};
    Object.values(WatermarkLocation).forEach((item) => {
      options[item] = {
        text: '',
        fontSize: 48,
        fontFamily: Fonts[0],
        color: defaultColor,
        opacity: 100,
        fontStyles: [],
      };
    });
    return options;
  }
  fillRange() {
    const opacityRange = this.opacityInput;
    if (this.watermarkSettings && opacityRange) {
      const opacity = Object.assign({}, this.watermarkSettings[this.watermarkLocation]).opacity.toString();
      opacityRange.style.background = `linear-gradient(to right, #212121 0%, #212121 ${opacity}%, #939393 ${opacity}%, #939393 100%)`;
    }
  }
  static get style() { return bmcfvWatermarkOptionsCss; }
};

const fvSandboxCss = ":host{display:block;height:100%}.sandbox-container{height:100%}.controls{margin-bottom:1em}.control{display:inline-block;margin-right:1em}bm-core-file-viewer{filter:drop-shadow(0 0 7px black);height:calc(100% - 157px)}";

/* eslint-disable camelcase */
const locales = {
  en_au: 'English - Australia',
  en_ca: 'English - Canada',
  en_gb: 'English - Great Britain',
  en: 'English',
  es: 'Spanish',
  fr: 'French',
  pt_br: 'Portuguese - Brasil'
};
const FvSandbox$1 = class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.webViewerPath = '/pdftron-webviewer/';
    this.document = undefined;
    this.locale = Locale.en;
    this.options = {
      canPrint: true,
      hideHeaderSeparators: true,
      showPageNavOverlayButtons: true,
      showViewControlsDropdown: false,
      showCogMenu: false,
      showHighlightTool: false,
      showFreeTextTool: false,
      headerOptions: {
        showOpenButton: true,
        showManageDropdown: true,
      }
    };
    this.documentName = '';
  }
  render() {
    return (h("div", { class: "sandbox-container" }, h("h1", null, "BM Core File Viewer"), h("div", { class: "controls" }, h("div", { class: "control" }, "WebViewer Path ", h("input", { type: "text", id: "webviewer-path", value: this.webViewerPath, onChange: e => this.onPathChange(e) })), h("div", { class: "control" }, "Document Name ", h("input", { type: "text", id: "document-name", onChange: e => this.onNameChange(e) })), h("div", { class: "control" }, h("input", { type: "file", id: "browse-button", onChange: e => this.onFileSelected(e) })), h("div", { class: "control" }, "Locale ", h("select", { onChange: e => this.onLocaleChanged(e) }, Object.keys(locales).map(l => this.localeOption(l)))), h("div", null, h("button", { id: "reload-options", onClick: () => this.reloadOptions() }, "Reload Options"))), h("bm-core-file-viewer", { "web-viewer-path": this.webViewerPath, document: this.document, "document-name": this.documentName, "custom-styles-path": getAssetPath(`./assets/web-viewer.css`), options: this.options, onWebViewerInstantiated: event => console.log('WebViewer instantiated', event), onDocumentLoaded: event => console.log('Document Loaded', event),
      // eslint-disable-next-line no-restricted-globals
      onCloseClicked: () => location.reload(), onDownloadClicked: () => console.log('Download Button Clicked') })));
  }
  localeOption(locale) {
    return h("option", { value: locale, selected: this.locale === locale }, locales[locale]);
  }
  onFileSelected(event) {
    const input = event.target;
    this.document = input.files.item(0);
  }
  onLocaleChanged(event) {
    const select = event.target;
    this.locale = select.value;
    this.options = { locale: this.locale };
  }
  onPathChange(event) {
    const input = event.target;
    this.webViewerPath = input.value;
  }
  onNameChange(event) {
    const input = event.target;
    this.documentName = input.value;
  }
  reloadOptions() {
    this.options = Object.assign({}, this.options);
  }
  static get assetsDirs() { return ["assets"]; }
  static get style() { return fvSandboxCss; }
};

const BmCoreFileViewer = /*@__PURE__*/proxyCustomElement(BmCoreFileViewer$1, [1,"bm-core-file-viewer",{"options":[16],"document":[1],"selectThumbnailPages":[2,"select-thumbnail-pages"],"documentOptions":[16],"webViewerPath":[1,"web-viewer-path"],"documentName":[1,"document-name"],"qeIdPrefix":[1,"qe-id-prefix"],"editAnnotations":[4,"edit-annotations"],"customStylesPath":[1,"custom-styles-path"],"toolbarActions":[16],"isCombinePDFBrokenPdfMessage":[4,"is-combine-p-d-f-broken-pdf-message"],"watermarkSettings":[32],"_retrievedDocumentName":[32],"isDocumentLoaded":[32],"fileViewerStrings":[32],"showPrintModal":[32],"showWatermarkModal":[32],"showPrintModalBusyLoader":[32],"isDocumentValid":[32]}]);
const BmcfvBusyLoader = /*@__PURE__*/proxyCustomElement(BmcfvBusyLoader$1, [1,"bmcfv-busy-loader"]);
const BmcfvColorPalette = /*@__PURE__*/proxyCustomElement(BmcfvColorPalette$1, [1,"bmcfv-color-palette",{"currentColor":[1,"current-color"]}]);
const BmcfvFileNotLoadedModal = /*@__PURE__*/proxyCustomElement(BmcfvFileNotLoadedModal$1, [1,"bmcfv-file-not-loaded-modal",{"qeIdPrefix":[1,"qe-id-prefix"],"isFileSupported":[4,"is-file-supported"],"fileViewerStrings":[16],"isCombinePDFBrokenPdfMessage":[4,"is-combine-p-d-f-broken-pdf-message"]}]);
const BmcfvHeader = /*@__PURE__*/proxyCustomElement(BmcfvHeader$1, [1,"bmcfv-header",{"qeIdPrefix":[1,"qe-id-prefix"],"documentName":[1,"document-name"],"options":[16],"showPrintButton":[4,"show-print-button"],"fileViewerStrings":[16]}]);
const BmcfvManagePopover = /*@__PURE__*/proxyCustomElement(BmcfvManagePopover$1, [1,"bmcfv-manage-popover",{"qeIdPrefix":[1,"qe-id-prefix"],"options":[16],"fileViewerStrings":[16]}]);
const BmcfvModalTemplate = /*@__PURE__*/proxyCustomElement(BmcfvModalTemplate$1, [4,"bmcfv-modal-template",{"contentHeight":[2,"content-height"],"modalId":[1,"modal-id"],"modalTitle":[1,"modal-title"],"closeButtonQeId":[1,"close-button-qe-id"]}]);
const BmcfvPrintOptions = /*@__PURE__*/proxyCustomElement(BmcfvPrintOptions$1, [1,"bmcfv-print-options",{"annotationsAllowed":[4,"annotations-allowed"],"fileViewerStrings":[16],"showBusyLoader":[4,"show-busy-loader"]}]);
const BmcfvWatermarkOptions = /*@__PURE__*/proxyCustomElement(BmcfvWatermarkOptions$1, [1,"bmcfv-watermark-options",{"watermarkSettings":[16],"watermarkLocation":[1,"watermark-location"],"isColorPaletteVisible":[4,"is-color-palette-visible"],"fileViewerStrings":[16]}]);
const FvSandbox = /*@__PURE__*/proxyCustomElement(FvSandbox$1, [1,"fv-sandbox",{"document":[32],"locale":[32],"options":[32],"documentName":[32]}]);
const defineCustomElements = (opts) => {
  if (typeof customElements !== 'undefined') {
    [
      BmCoreFileViewer,
  BmcfvBusyLoader,
  BmcfvColorPalette,
  BmcfvFileNotLoadedModal,
  BmcfvHeader,
  BmcfvManagePopover,
  BmcfvModalTemplate,
  BmcfvPrintOptions,
  BmcfvWatermarkOptions,
  FvSandbox
    ].forEach(cmp => {
      if (!customElements.get(cmp.is)) {
        customElements.define(cmp.is, cmp, opts);
      }
    });
  }
};

export { BmCoreFileViewer, BmcfvBusyLoader, BmcfvColorPalette, BmcfvFileNotLoadedModal, BmcfvHeader, BmcfvManagePopover, BmcfvModalTemplate, BmcfvPrintOptions, BmcfvWatermarkOptions, FvSandbox, Locale, PdfTronFeature$1 as PdfTronFeature, WebViewerElement, cogMenu, defineCustomElements, viewControlsDropdown };
